
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cS7ok", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $i9pyX = parcelRequire("i9pyX");


var $dv1ov = parcelRequire("dv1ov");


var $33u17 = parcelRequire("33u17");


var $fIdaz = parcelRequire("fIdaz");


var $lG3cK = parcelRequire("lG3cK");


var $23xJD = parcelRequire("23xJD");


var $0SpY7 = parcelRequire("0SpY7");


var $lKvkH = parcelRequire("lKvkH");


var $d396o = parcelRequire("d396o");


var $aqAfG = parcelRequire("aqAfG");


var $5OPAY = parcelRequire("5OPAY");


var $aoy1P = parcelRequire("aoy1P");


var $fR63l = parcelRequire("fR63l");


var $dAuCI = parcelRequire("dAuCI");


var $3eS8z = parcelRequire("3eS8z");


var $92KTD = parcelRequire("92KTD");


var $7fkiQ = parcelRequire("7fkiQ");


var $eSwze = parcelRequire("eSwze");

const $b217d7e94854b92c$var$EXTRACT_PRODUCT = /ari:cloud:(.*)?::/;
const $b217d7e94854b92c$var$BITBUCKET_WORKSPACE_ARI = 'ari:cloud:bitbucket::workspace';
const $b217d7e94854b92c$var$FEDERATED_NO_OAUTH_PRODUCT_KEYS = new Set([
    'servicenow',
    'zendesk'
]);
/**
 * Normalizes product names from ARIs to match our product keys.
 * Backend uses 'jira-software' in ARIs but we use 'jira' as the product key.
 */ const $b217d7e94854b92c$var$normalizeProductFromAri = (ariProduct)=>{
    if (ariProduct === 'jira-software') return (0, $aqAfG.ProductKeys1P).Jira;
    return ariProduct;
};
/**
 * Nouns configuration (simplified - no icons for now)
 */ const $b217d7e94854b92c$var$supportedNouns = {
    [(0, $aqAfG.NounKeys).project]: {},
    [(0, $aqAfG.NounKeys).goal]: {},
    [(0, $aqAfG.NounKeys).AtlassianWebCrawler]: {}
};
/**
 * All product keys - 1P combined with 3P
 */ const $b217d7e94854b92c$var$allProductKeys = [
    ...Object.values((0, $aqAfG.ARI_EXTRACTED_1P_KEYS)),
    ...(0, $dAuCI.ThirdPartyConfigs).keys()
];
/**
 * Some products (eg. Loom) have separate auth checks that need to be enforced before
 * returning the final list of accessible products.
 *
 * Remove when cleaning up fg('rovo-search-combined-loom-auth')
 */ const $b217d7e94854b92c$var$lastMileProductChecks = (isUserLoomAuthed, products)=>{
    if (!products || products.length === 0) return products;
    return products.filter((product)=>isUserLoomAuthed || product !== (0, $fR63l.ProductKeys3P).Loom);
};
const $b217d7e94854b92c$export$2b0ac18f7cd43e19 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(90);
    const { cloudId: cloudIdProp, configFetchAbsoluteUrl: configFetchAbsoluteUrl, aggregatorHostName: aggregatorHostName, userId: userId, thirdPartyAbsoluteUrl: thirdPartyAbsoluteUrl, thirdPartyDisabled: thirdPartyDisabled, primaryProduct: primaryProduct, aggAbsoluteUrl: aggAbsoluteUrl, multiSiteSearchInRovo: multiSiteSearchInRovo, experience: experience, analytics: analytics } = t0;
    const { fireAnalyticsEvent: fireAnalyticsEvent, logException: logException, searchSessionId: searchSessionId, source: source, actionSubject: actionSubject, taskNamePrefix: taskNamePrefix, createNetworkCallbacks: createNetworkCallbacks } = analytics;
    const [firstPartyResponse, setFirstPartyResponse] = (0, $cozmU.useState)();
    const [isConfigLoaded, setIsConfigLoaded] = (0, $cozmU.useState)(false);
    const [isUserLoomAuthed, setIsUserLoomAuthed] = (0, $cozmU.useState)(false);
    const [linkedCloudARIs, setLinkedCloudARIs] = (0, $cozmU.useState)(undefined);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            nouns: []
        };
        $[0] = t1;
    } else t1 = $[0];
    const [accessibleProductsConfig, setAccessibleProductsConfig] = (0, $cozmU.useState)(t1);
    let t2;
    bb0: {
        if (!cloudIdProp && firstPartyResponse) {
            let t3;
            if ($[1] !== firstPartyResponse) {
                t3 = (0, $5OPAY.getFirstCloudId)(firstPartyResponse);
                $[1] = firstPartyResponse;
                $[2] = t3;
            } else t3 = $[2];
            t2 = t3;
            break bb0;
        }
        t2 = "";
    }
    const firstCloudId = t2;
    const t3 = cloudIdProp || firstCloudId || "";
    let t4;
    if ($[3] !== analytics || $[4] !== experience || $[5] !== t3 || $[6] !== thirdPartyAbsoluteUrl || $[7] !== thirdPartyDisabled || $[8] !== userId) {
        t4 = {
            cloudId: t3,
            userId: userId,
            absoluteUrl: thirdPartyAbsoluteUrl,
            disabled: thirdPartyDisabled,
            experience: experience,
            analytics: analytics
        };
        $[3] = analytics;
        $[4] = experience;
        $[5] = t3;
        $[6] = thirdPartyAbsoluteUrl;
        $[7] = thirdPartyDisabled;
        $[8] = userId;
        $[9] = t4;
    } else t4 = $[9];
    const thirdPartyResponse = $b217d7e94854b92c$export$4fc2f66fb6e9d067(t4);
    let t5;
    let t6;
    if ($[10] !== aggAbsoluteUrl || $[11] !== cloudIdProp || $[12] !== firstCloudId || $[13] !== logException || $[14] !== multiSiteSearchInRovo) {
        t5 = ()=>{
            const cloudId = cloudIdProp || firstCloudId;
            if (cloudId && multiSiteSearchInRovo) (0, $dv1ov.searchLinkedSitesQuery)({
                variables: {
                    id: `ari:cloud:confluence::site/${cloudId}`
                },
                aggAbsoluteUrl: aggAbsoluteUrl
            }).then((response)=>{
                const edges = response?.data?.collabContext_workspaceIsConnectedToWorkspace?.edges ?? [];
                const linkedARIs = edges.map($b217d7e94854b92c$var$_temp);
                const currentCloudIdARI = `ari:cloud:confluence::site/${cloudId}`;
                const currentIndex = linkedARIs.findIndex((ari)=>ari === currentCloudIdARI);
                if (currentIndex > 0) {
                    linkedARIs.splice(currentIndex, 1);
                    linkedARIs.unshift(currentCloudIdARI);
                }
                setLinkedCloudARIs(linkedARIs);
            }).catch((error)=>{
                logException(error);
            });
        };
        t6 = [
            cloudIdProp,
            firstCloudId,
            multiSiteSearchInRovo,
            logException,
            aggAbsoluteUrl
        ];
        $[10] = aggAbsoluteUrl;
        $[11] = cloudIdProp;
        $[12] = firstCloudId;
        $[13] = logException;
        $[14] = multiSiteSearchInRovo;
        $[15] = t5;
        $[16] = t6;
    } else {
        t5 = $[15];
        t6 = $[16];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    let t8;
    if ($[17] !== cloudIdProp || $[18] !== isUserLoomAuthed || $[19] !== logException || $[20] !== primaryProduct || $[21] !== userId) {
        t7 = ()=>{
            if (!(0, $iDrrr.fg)("rovo-search-combined-loom-auth") && !isUserLoomAuthed) {
                if (primaryProduct === (0, $d396o.PrimaryProductKeys).Confluence || primaryProduct === (0, $d396o.PrimaryProductKeys).Atlas || (primaryProduct === (0, $d396o.PrimaryProductKeys).Jira || primaryProduct === (0, $d396o.PrimaryProductKeys).Focus) && (0, $iDrrr.fg)("search_loom_auth_check_in_jira_mercury")) (0, $i9pyX.getUserLoomAuthStatus)({
                    userId: userId,
                    cloudId: cloudIdProp
                }).then((response_0)=>setIsUserLoomAuthed(response_0?.status === "mastered")).catch((error_0)=>{
                    logException(error_0);
                    setIsUserLoomAuthed(false);
                });
                else setIsUserLoomAuthed(true);
            }
        };
        t8 = [
            isUserLoomAuthed,
            setIsUserLoomAuthed,
            userId,
            logException,
            cloudIdProp,
            primaryProduct
        ];
        $[17] = cloudIdProp;
        $[18] = isUserLoomAuthed;
        $[19] = logException;
        $[20] = primaryProduct;
        $[21] = userId;
        $[22] = t7;
        $[23] = t8;
    } else {
        t7 = $[22];
        t8 = $[23];
    }
    (0, $cozmU.useEffect)(t7, t8);
    let t10;
    let t9;
    if ($[24] !== actionSubject || $[25] !== aggregatorHostName || $[26] !== cloudIdProp || $[27] !== configFetchAbsoluteUrl || $[28] !== createNetworkCallbacks || $[29] !== experience || $[30] !== fireAnalyticsEvent || $[31] !== firstPartyResponse || $[32] !== logException || $[33] !== searchSessionId || $[34] !== source || $[35] !== taskNamePrefix || $[36] !== userId) {
        t9 = ()=>{
            if (!firstPartyResponse) {
                const taskStartAt = performance.now();
                const taskId = crypto.randomUUID();
                const degradationCallback = (reason)=>{
                    fireAnalyticsEvent((0, $3eS8z.onDegradedDependency)({
                        dependency: "search-config",
                        searchSessionId: searchSessionId,
                        reason: reason,
                        source: source,
                        actionSubject: actionSubject
                    }));
                };
                const cacheAnalyticsCallback = async (state)=>{
                    fireAnalyticsEvent((0, $3eS8z.onRequestCacheAccess)({
                        requestName: "search-config",
                        searchSessionId: searchSessionId,
                        cacheHit: state.hit,
                        refreshTriggered: state.refreshTriggered,
                        source: source,
                        actionSubject: actionSubject
                    }));
                };
                const networkCallbacks = createNetworkCallbacks ? createNetworkCallbacks(taskId, (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_NETWORK), searchSessionId, fireAnalyticsEvent, taskStartAt, {}) : undefined;
                const searchConfigParams = {
                    cloudId: cloudIdProp,
                    absoluteUrl: configFetchAbsoluteUrl,
                    hostName: aggregatorHostName,
                    userId: userId,
                    degradationCallback: degradationCallback,
                    cacheAnalyticsCallback: cacheAnalyticsCallback,
                    expiration: 900000,
                    returnExpired: true,
                    onlyRefreshIfExpired: true,
                    networkCallbacks: networkCallbacks
                };
                fireAnalyticsEvent((0, $3eS8z.onTaskStart)({
                    searchSessionId: searchSessionId,
                    taskId: taskId,
                    task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_UX),
                    moreContext: {
                        experience: experience
                    }
                }));
                (0, $i9pyX.getSearchConfigV2)(searchConfigParams).then((response_1)=>{
                    setFirstPartyResponse(response_1);
                    fireAnalyticsEvent((0, $3eS8z.onTaskSuccess)({
                        searchSessionId: searchSessionId,
                        taskId: taskId,
                        task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_UX),
                        moreContext: {
                            timeTaken: performance.now() - taskStartAt,
                            experience: experience
                        }
                    }));
                }).catch((error_1)=>{
                    logException(error_1);
                    fireAnalyticsEvent((0, $3eS8z.onFailedDependency)({
                        dependency: "search-config",
                        searchSessionId: searchSessionId,
                        source: source,
                        actionSubject: actionSubject
                    }));
                    fireAnalyticsEvent((0, $3eS8z.onTaskFail)({
                        searchSessionId: searchSessionId,
                        taskId: taskId,
                        task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_UX),
                        moreContext: {
                            error: error_1.name,
                            timeTaken: performance.now() - taskStartAt,
                            experience: experience
                        }
                    }));
                    setFirstPartyResponse({
                        resources: [],
                        intercomHmac: "",
                        siteMetadata: []
                    });
                });
            }
        };
        t10 = [
            firstPartyResponse,
            setFirstPartyResponse,
            cloudIdProp,
            configFetchAbsoluteUrl,
            aggregatorHostName,
            userId,
            logException,
            fireAnalyticsEvent,
            searchSessionId,
            source,
            actionSubject,
            taskNamePrefix,
            createNetworkCallbacks,
            experience
        ];
        $[24] = actionSubject;
        $[25] = aggregatorHostName;
        $[26] = cloudIdProp;
        $[27] = configFetchAbsoluteUrl;
        $[28] = createNetworkCallbacks;
        $[29] = experience;
        $[30] = fireAnalyticsEvent;
        $[31] = firstPartyResponse;
        $[32] = logException;
        $[33] = searchSessionId;
        $[34] = source;
        $[35] = taskNamePrefix;
        $[36] = userId;
        $[37] = t10;
        $[38] = t9;
    } else {
        t10 = $[37];
        t9 = $[38];
    }
    (0, $cozmU.useEffect)(t9, t10);
    let t11;
    if ($[39] !== accessibleProductsConfig.products || $[40] !== cloudIdProp || $[41] !== firstPartyResponse || $[42] !== primaryProduct || $[43] !== thirdPartyResponse.productKeys || $[44] !== thirdPartyResponse.thirdPartyConfigs) {
        t11 = ()=>{
            if (thirdPartyResponse.productKeys && firstPartyResponse && !accessibleProductsConfig.products) {
                let allAccessibleProducts = [];
                const firstPartyProducts = [
                    ...new Set(firstPartyResponse.resources.flatMap($b217d7e94854b92c$var$_temp2))
                ];
                if (firstPartyProducts.length === 0 && primaryProduct) allAccessibleProducts.push(primaryProduct);
                else allAccessibleProducts.push(...firstPartyProducts);
                const areNounsEnabledThroughLegacyFlag = (0, $0SpY7.isNounsAvailable)(firstPartyResponse, cloudIdProp);
                const accessibleNouns = areNounsEnabledThroughLegacyFlag ? [] : firstPartyResponse.resources.flatMap($b217d7e94854b92c$var$_temp3);
                if (accessibleNouns.length > 0 && !areNounsEnabledThroughLegacyFlag) allAccessibleProducts.push((0, $aqAfG.ProductKeys1P).Atlas);
                if (allAccessibleProducts.includes("bitbucket") && !firstPartyResponse.resources.find($b217d7e94854b92c$var$_temp4)) allAccessibleProducts = allAccessibleProducts.filter($b217d7e94854b92c$var$_temp5);
                const doesUserHaveRovo = (0, $lKvkH.isRovoEnabled)(firstPartyResponse, cloudIdProp);
                if (doesUserHaveRovo) {
                    const thirdPartyProductKeys = thirdPartyResponse.productKeys || [];
                    allAccessibleProducts.push(...thirdPartyProductKeys);
                    setAccessibleProductsConfig({
                        products: allAccessibleProducts,
                        nouns: accessibleNouns,
                        thirdPartyConfigs: thirdPartyResponse.thirdPartyConfigs
                    });
                } else setAccessibleProductsConfig({
                    products: allAccessibleProducts,
                    nouns: accessibleNouns,
                    thirdPartyConfigs: {}
                });
                setIsConfigLoaded(true);
            }
        };
        $[39] = accessibleProductsConfig.products;
        $[40] = cloudIdProp;
        $[41] = firstPartyResponse;
        $[42] = primaryProduct;
        $[43] = thirdPartyResponse.productKeys;
        $[44] = thirdPartyResponse.thirdPartyConfigs;
        $[45] = t11;
    } else t11 = $[45];
    let t12;
    if ($[46] !== accessibleProductsConfig.products || $[47] !== cloudIdProp || $[48] !== fireAnalyticsEvent || $[49] !== firstPartyResponse || $[50] !== isUserLoomAuthed || $[51] !== logException || $[52] !== primaryProduct || $[53] !== thirdPartyResponse) {
        t12 = [
            isUserLoomAuthed,
            thirdPartyResponse,
            firstPartyResponse,
            setAccessibleProductsConfig,
            primaryProduct,
            fireAnalyticsEvent,
            logException,
            cloudIdProp,
            accessibleProductsConfig.products
        ];
        $[46] = accessibleProductsConfig.products;
        $[47] = cloudIdProp;
        $[48] = fireAnalyticsEvent;
        $[49] = firstPartyResponse;
        $[50] = isUserLoomAuthed;
        $[51] = logException;
        $[52] = primaryProduct;
        $[53] = thirdPartyResponse;
        $[54] = t12;
    } else t12 = $[54];
    (0, $cozmU.useEffect)(t11, t12);
    let t13;
    if ($[55] !== accessibleProductsConfig.products || $[56] !== isUserLoomAuthed) {
        t13 = (0, $iDrrr.fg)("rovo-search-combined-loom-auth") ? accessibleProductsConfig.products : $b217d7e94854b92c$var$lastMileProductChecks(isUserLoomAuthed, accessibleProductsConfig.products);
        $[55] = accessibleProductsConfig.products;
        $[56] = isUserLoomAuthed;
        $[57] = t13;
    } else t13 = $[57];
    const accessibleProducts = t13;
    const t14 = accessibleProductsConfig.nouns;
    const t15 = accessibleProductsConfig.thirdPartyConfigs;
    const t16 = firstPartyResponse?.intercomHmac;
    let t17;
    if ($[58] !== cloudIdProp || $[59] !== firstPartyResponse) {
        t17 = (0, $0SpY7.isNounsAvailable)(firstPartyResponse, cloudIdProp);
        $[58] = cloudIdProp;
        $[59] = firstPartyResponse;
        $[60] = t17;
    } else t17 = $[60];
    let t18;
    if ($[61] !== cloudIdProp || $[62] !== firstPartyResponse) {
        t18 = (0, $lKvkH.isRovoEnabled)(firstPartyResponse, cloudIdProp);
        $[61] = cloudIdProp;
        $[62] = firstPartyResponse;
        $[63] = t18;
    } else t18 = $[63];
    let t19;
    if ($[64] !== cloudIdProp || $[65] !== firstPartyResponse) {
        t19 = (0, $33u17.getJiraIssueIndexedForTenant)(firstPartyResponse, cloudIdProp);
        $[64] = cloudIdProp;
        $[65] = firstPartyResponse;
        $[66] = t19;
    } else t19 = $[66];
    let t20;
    if ($[67] !== cloudIdProp || $[68] !== firstPartyResponse) {
        t20 = (0, $lG3cK.getProductEdition)(firstPartyResponse, cloudIdProp);
        $[67] = cloudIdProp;
        $[68] = firstPartyResponse;
        $[69] = t20;
    } else t20 = $[69];
    let t21;
    if ($[70] !== cloudIdProp || $[71] !== firstPartyResponse) {
        t21 = (0, $fIdaz.getProductDataRegions)(firstPartyResponse, cloudIdProp);
        $[70] = cloudIdProp;
        $[71] = firstPartyResponse;
        $[72] = t21;
    } else t21 = $[72];
    let t22;
    if ($[73] !== cloudIdProp || $[74] !== firstPartyResponse) {
        t22 = (0, $23xJD.getRovoFeatures)(firstPartyResponse, cloudIdProp);
        $[73] = cloudIdProp;
        $[74] = firstPartyResponse;
        $[75] = t22;
    } else t22 = $[75];
    let t23;
    if ($[76] !== accessibleProducts || $[77] !== accessibleProductsConfig.nouns || $[78] !== accessibleProductsConfig.thirdPartyConfigs || $[79] !== firstCloudId || $[80] !== isConfigLoaded || $[81] !== linkedCloudARIs || $[82] !== t16 || $[83] !== t17 || $[84] !== t18 || $[85] !== t19 || $[86] !== t20 || $[87] !== t21 || $[88] !== t22) {
        t23 = {
            accessibleProducts: accessibleProducts,
            accessibleNouns: t14,
            thirdPartyConfigs: t15,
            firstCloudId: firstCloudId,
            intercomHmac: t16,
            isNounsAvailable: t17,
            isRovoEnabled: t18,
            isJiraIssueIndexed: t19,
            productEdition: t20,
            productDataRegions: t21,
            rovoFeatures: t22,
            isConfigLoaded: isConfigLoaded,
            linkedCloudARIs: linkedCloudARIs
        };
        $[76] = accessibleProducts;
        $[77] = accessibleProductsConfig.nouns;
        $[78] = accessibleProductsConfig.thirdPartyConfigs;
        $[79] = firstCloudId;
        $[80] = isConfigLoaded;
        $[81] = linkedCloudARIs;
        $[82] = t16;
        $[83] = t17;
        $[84] = t18;
        $[85] = t19;
        $[86] = t20;
        $[87] = t21;
        $[88] = t22;
        $[89] = t23;
    } else t23 = $[89];
    return t23;
} : ({ cloudId: cloudIdProp, configFetchAbsoluteUrl: configFetchAbsoluteUrl, aggregatorHostName: aggregatorHostName, userId: userId, thirdPartyAbsoluteUrl: thirdPartyAbsoluteUrl, thirdPartyDisabled: thirdPartyDisabled, primaryProduct: primaryProduct, aggAbsoluteUrl: aggAbsoluteUrl, multiSiteSearchInRovo: multiSiteSearchInRovo, experience: experience, analytics: analytics })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent, logException: logException, searchSessionId: searchSessionId, source: source, actionSubject: actionSubject, taskNamePrefix: taskNamePrefix, createNetworkCallbacks: createNetworkCallbacks } = analytics;
    const [firstPartyResponse, setFirstPartyResponse] = (0, $cozmU.useState)();
    const [isConfigLoaded, setIsConfigLoaded] = (0, $cozmU.useState)(false);
    // Loom requires a separate auth check
    const [isUserLoomAuthed, setIsUserLoomAuthed] = (0, $cozmU.useState)(false);
    // Rovo Multiple Site Search
    const [linkedCloudARIs, setLinkedCloudARIs] = (0, $cozmU.useState)(undefined);
    const [accessibleProductsConfig, setAccessibleProductsConfig] = (0, $cozmU.useState)({
        nouns: []
    });
    const firstCloudId = (0, $cozmU.useMemo)(()=>{
        if (!cloudIdProp && firstPartyResponse) return (0, $5OPAY.getFirstCloudId)(firstPartyResponse);
        return '';
    }, [
        firstPartyResponse,
        cloudIdProp
    ]);
    const thirdPartyResponse = $b217d7e94854b92c$export$4fc2f66fb6e9d067({
        cloudId: cloudIdProp || firstCloudId || '',
        userId: userId,
        absoluteUrl: thirdPartyAbsoluteUrl,
        disabled: thirdPartyDisabled,
        experience: experience,
        analytics: analytics
    });
    // Rovo Multiple Site Search - Store linked site ARIs in state
    (0, $cozmU.useEffect)(()=>{
        const cloudId = cloudIdProp || firstCloudId;
        if (cloudId && multiSiteSearchInRovo) (0, $dv1ov.searchLinkedSitesQuery)({
            variables: {
                id: `ari:cloud:confluence::site/${cloudId}`
            },
            aggAbsoluteUrl: aggAbsoluteUrl
        }).then((response)=>{
            const edges = response?.data?.collabContext_workspaceIsConnectedToWorkspace?.edges ?? [];
            const linkedARIs = edges.map((edge)=>edge.node.id);
            const currentCloudIdARI = `ari:cloud:confluence::site/${cloudId}`;
            const currentIndex = linkedARIs.findIndex((ari)=>ari === currentCloudIdARI);
            if (currentIndex > 0) {
                linkedARIs.splice(currentIndex, 1);
                linkedARIs.unshift(currentCloudIdARI);
            }
            setLinkedCloudARIs(linkedARIs);
        }).catch((error)=>{
            logException(error);
        });
    }, [
        cloudIdProp,
        firstCloudId,
        multiSiteSearchInRovo,
        logException,
        aggAbsoluteUrl
    ]);
    // Loom auth check
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('rovo-search-combined-loom-auth') && !isUserLoomAuthed) {
            if (primaryProduct === (0, $d396o.PrimaryProductKeys).Confluence || primaryProduct === (0, $d396o.PrimaryProductKeys).Atlas || (primaryProduct === (0, $d396o.PrimaryProductKeys).Jira || primaryProduct === (0, $d396o.PrimaryProductKeys).Focus) && (0, $iDrrr.fg)('search_loom_auth_check_in_jira_mercury')) (0, $i9pyX.getUserLoomAuthStatus)({
                userId: userId,
                cloudId: cloudIdProp
            }).then((response_0)=>setIsUserLoomAuthed(response_0?.status === 'mastered')).catch((error_0)=>{
                logException(error_0);
                setIsUserLoomAuthed(false);
            });
            else setIsUserLoomAuthed(true);
        }
    }, [
        isUserLoomAuthed,
        setIsUserLoomAuthed,
        userId,
        logException,
        cloudIdProp,
        primaryProduct
    ]);
    // Fetch 1P config
    (0, $cozmU.useEffect)(()=>{
        if (!firstPartyResponse) {
            const taskStartAt = performance.now();
            const taskId = crypto.randomUUID();
            const degradationCallback = (reason)=>{
                fireAnalyticsEvent((0, $3eS8z.onDegradedDependency)({
                    dependency: 'search-config',
                    searchSessionId: searchSessionId,
                    reason: reason,
                    source: source,
                    actionSubject: actionSubject
                }));
            };
            const cacheAnalyticsCallback = async (state)=>{
                fireAnalyticsEvent((0, $3eS8z.onRequestCacheAccess)({
                    requestName: 'search-config',
                    searchSessionId: searchSessionId,
                    cacheHit: state.hit,
                    refreshTriggered: state.refreshTriggered,
                    source: source,
                    actionSubject: actionSubject
                }));
            };
            const search1PConfigTTL = 900000; // 15 minutes
            const networkCallbacks = createNetworkCallbacks ? createNetworkCallbacks(taskId, (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_NETWORK), searchSessionId, fireAnalyticsEvent, taskStartAt, {}) : undefined;
            const searchConfigParams = {
                cloudId: cloudIdProp,
                absoluteUrl: configFetchAbsoluteUrl,
                hostName: aggregatorHostName,
                userId: userId,
                degradationCallback: degradationCallback,
                cacheAnalyticsCallback: cacheAnalyticsCallback,
                expiration: search1PConfigTTL,
                returnExpired: true,
                onlyRefreshIfExpired: true,
                networkCallbacks: networkCallbacks
            };
            fireAnalyticsEvent((0, $3eS8z.onTaskStart)({
                searchSessionId: searchSessionId,
                taskId: taskId,
                task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_UX),
                moreContext: {
                    experience: experience
                }
            }));
            (0, $i9pyX.getSearchConfigV2)(searchConfigParams).then((response_1)=>{
                setFirstPartyResponse(response_1);
                fireAnalyticsEvent((0, $3eS8z.onTaskSuccess)({
                    searchSessionId: searchSessionId,
                    taskId: taskId,
                    task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_UX),
                    moreContext: {
                        timeTaken: performance.now() - taskStartAt,
                        experience: experience
                    }
                }));
            }).catch((error_1)=>{
                logException(error_1);
                fireAnalyticsEvent((0, $3eS8z.onFailedDependency)({
                    dependency: 'search-config',
                    searchSessionId: searchSessionId,
                    source: source,
                    actionSubject: actionSubject
                }));
                fireAnalyticsEvent((0, $3eS8z.onTaskFail)({
                    searchSessionId: searchSessionId,
                    taskId: taskId,
                    task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_UX),
                    moreContext: {
                        error: error_1.name,
                        timeTaken: performance.now() - taskStartAt,
                        experience: experience
                    }
                }));
                setFirstPartyResponse({
                    resources: [],
                    intercomHmac: '',
                    siteMetadata: []
                });
            });
        }
    }, [
        firstPartyResponse,
        setFirstPartyResponse,
        cloudIdProp,
        configFetchAbsoluteUrl,
        aggregatorHostName,
        userId,
        logException,
        fireAnalyticsEvent,
        searchSessionId,
        source,
        actionSubject,
        taskNamePrefix,
        createNetworkCallbacks,
        experience
    ]);
    // Combine 1P and 3P config
    (0, $cozmU.useEffect)(()=>{
        if (thirdPartyResponse.productKeys && firstPartyResponse && !accessibleProductsConfig.products) {
            let allAccessibleProducts = [];
            const firstPartyProducts = [
                ...new Set(firstPartyResponse.resources.flatMap((resource)=>{
                    const { id: id } = resource;
                    const match = id.match($b217d7e94854b92c$var$EXTRACT_PRODUCT);
                    if (match && match.length >= 2) {
                        const normalizedProduct = $b217d7e94854b92c$var$normalizeProductFromAri(match[1]);
                        if ((0, $aqAfG.ARI_EXTRACTED_1P_KEYS).includes(normalizedProduct)) return [
                            normalizedProduct
                        ];
                        // Loom delivers a 1P-style ARI (ari:cloud:loom::site/...) but is classified
                        // as a 3P product (ProductKeys3P.Loom).
                        if (normalizedProduct === (0, $fR63l.ProductKeys3P).Loom) return [
                            normalizedProduct
                        ];
                    }
                    return [];
                }))
            ];
            if (firstPartyProducts.length === 0 && primaryProduct) allAccessibleProducts.push(primaryProduct);
            else allAccessibleProducts.push(...firstPartyProducts);
            const areNounsEnabledThroughLegacyFlag = (0, $0SpY7.isNounsAvailable)(firstPartyResponse, cloudIdProp);
            const accessibleNouns = areNounsEnabledThroughLegacyFlag ? [] : firstPartyResponse.resources.flatMap((resource_0)=>{
                const { id: id_0 } = resource_0;
                const match_0 = id_0.match($b217d7e94854b92c$var$EXTRACT_PRODUCT);
                if (match_0 && match_0.length >= 2 && match_0[1] in $b217d7e94854b92c$var$supportedNouns) return [
                    match_0[1]
                ];
                return [];
            });
            if (accessibleNouns.length > 0 && !areNounsEnabledThroughLegacyFlag) allAccessibleProducts.push((0, $aqAfG.ProductKeys1P).Atlas);
            if (allAccessibleProducts.includes('bitbucket') && !firstPartyResponse.resources.find((r)=>r.id.includes($b217d7e94854b92c$var$BITBUCKET_WORKSPACE_ARI))) allAccessibleProducts = allAccessibleProducts.filter((product)=>product !== (0, $aqAfG.ProductKeys1P).Bitbucket);
            const doesUserHaveRovo = (0, $lKvkH.isRovoEnabled)(firstPartyResponse, cloudIdProp);
            if (doesUserHaveRovo) {
                const thirdPartyProductKeys = thirdPartyResponse.productKeys || [];
                allAccessibleProducts.push(...thirdPartyProductKeys);
                setAccessibleProductsConfig({
                    products: allAccessibleProducts,
                    nouns: accessibleNouns,
                    thirdPartyConfigs: thirdPartyResponse.thirdPartyConfigs
                });
            } else setAccessibleProductsConfig({
                products: allAccessibleProducts,
                nouns: accessibleNouns,
                thirdPartyConfigs: {}
            });
            setIsConfigLoaded(true);
        }
    }, [
        isUserLoomAuthed,
        thirdPartyResponse,
        firstPartyResponse,
        setAccessibleProductsConfig,
        primaryProduct,
        fireAnalyticsEvent,
        logException,
        cloudIdProp,
        accessibleProductsConfig.products
    ]);
    const accessibleProducts = (0, $iDrrr.fg)('rovo-search-combined-loom-auth') ? accessibleProductsConfig.products : $b217d7e94854b92c$var$lastMileProductChecks(isUserLoomAuthed, accessibleProductsConfig.products);
    return {
        accessibleProducts: accessibleProducts,
        accessibleNouns: accessibleProductsConfig.nouns,
        thirdPartyConfigs: accessibleProductsConfig.thirdPartyConfigs,
        firstCloudId: firstCloudId,
        intercomHmac: firstPartyResponse?.intercomHmac,
        isNounsAvailable: (0, $0SpY7.isNounsAvailable)(firstPartyResponse, cloudIdProp),
        isRovoEnabled: (0, $lKvkH.isRovoEnabled)(firstPartyResponse, cloudIdProp),
        isJiraIssueIndexed: (0, $33u17.getJiraIssueIndexedForTenant)(firstPartyResponse, cloudIdProp),
        productEdition: (0, $lG3cK.getProductEdition)(firstPartyResponse, cloudIdProp),
        productDataRegions: (0, $fIdaz.getProductDataRegions)(firstPartyResponse, cloudIdProp),
        rovoFeatures: (0, $23xJD.getRovoFeatures)(firstPartyResponse, cloudIdProp),
        isConfigLoaded: isConfigLoaded,
        linkedCloudARIs: linkedCloudARIs
    };
};
const $b217d7e94854b92c$export$6750011b01164bda = async ()=>{
    const oldThirdPartyTypes = {
        'ai-3p-connector:sharepoint-domain': 'sharepoint',
        'ai-3p-connector:google-workspace': 'drive'
    };
    const thirdPartyTypes = {
        ...oldThirdPartyTypes,
        'lite-connector-gdrive': 'drive',
        'smartlinks-connector-gdrive': 'drive',
        'smartlinks-connector-gdrive-rsl': 'drive',
        'smartlinks-connector-salesforce': 'salesforce',
        'smartlinks-connector-airtable': 'airtable',
        'smartlinks-connector-figma': 'figma',
        'smartlinks-connector-gitlab': 'gitlab',
        'smartlinks-connector-miro': 'miro',
        'smartlinks-connector-asana': 'asana',
        'smartlinks-connector-smartsheet': 'smartsheet',
        'smartlinks-connector-dropbox': 'dropbox',
        'smartlinks-connector-box': 'box',
        'smartlinks-connector-lucid': 'lucid',
        'smartlinks-connector-hubspot': 'hubspot',
        'smartlinks-connector-docusign': 'docusign',
        'smartlinks-connector-slack': 'slack',
        'smartlinks-connector-teams': 'teams',
        'smartlinks-connector-azure-devops': 'azure-devops',
        'smartlinks-connector-notion': 'notion',
        'smartlinks-connector-onedrive': 'onedrive',
        'smartlinks-connector-sharepoint': 'sharepoint'
    };
    await (0, $dAuCI.ThirdPartyConfigs).forEach((config)=>{
        if (config.resourceType) thirdPartyTypes[config.resourceType] = config.id;
    });
    return thirdPartyTypes;
};
const $b217d7e94854b92c$export$b58c1135b7f9df6d = async ({ cloudId: cloudId, absoluteUrl: absoluteUrl, userId: userId, degradationCallback: degradationCallback, cacheAnalyticsCallback: cacheAnalyticsCallback, networkCallbacks: networkCallbacks })=>{
    const THIRD_PARTY_TYPES = await $b217d7e94854b92c$export$6750011b01164bda();
    const searchConfigParams = {
        cloudId: cloudId,
        absoluteUrl: absoluteUrl,
        userId: userId,
        degradationCallback: degradationCallback,
        cacheAnalyticsCallback: cacheAnalyticsCallback,
        expiration: 60000,
        // 1 minute
        returnExpired: true,
        onlyRefreshIfExpired: true,
        networkCallbacks: networkCallbacks
    };
    const resources = await (0, $i9pyX.get3pSearchConfig)(searchConfigParams);
    const connectorSourceMap = new Map();
    let productKeys = [];
    let thirdPartyConfigsWithAPIResponse = {};
    for (const resource of resources){
        if ((0, $aoy1P.isForgeConnectorProductKey)(resource.type) && (0, $iDrrr.fg)('rovo-search-dynamic-forge-config')) {
            const config = (0, $eSwze.mapForgeConnectorToThirdPartyConfig)(resource);
            if (config) {
                const productKey = resource.type;
                productKeys.push(productKey);
                thirdPartyConfigsWithAPIResponse[productKey] = config;
            }
            continue;
        }
        const productKey = THIRD_PARTY_TYPES[resource.type] || '';
        if (!productKey) continue;
        const { providerId: providerId, datasourceId: datasourceId } = resource;
        productKeys.push(productKey);
        let config = {};
        const staticConfig = await (0, $dAuCI.ThirdPartyConfigs).get(productKey);
        if (staticConfig) {
            const isFederatedNoOAuthConnector = $b217d7e94854b92c$var$FEDERATED_NO_OAUTH_PRODUCT_KEYS.has(productKey) && resource.connectorSyncType === (0, $aoy1P.FEDERATED_CONNECTOR_SOURCE);
            let sourceType;
            if (resource.type.startsWith((0, $aoy1P.SMARTLINKS_CONNECTOR_SOURCE))) sourceType = (0, $aoy1P.SMARTLINKS_CONNECTOR_SOURCE);
            else if (resource.type.startsWith((0, $aoy1P.LITE_CONNECTOR_SOURCE))) sourceType = (0, $aoy1P.LITE_CONNECTOR_SOURCE);
            else if (isFederatedNoOAuthConnector) sourceType = (0, $aoy1P.FEDERATED_CONNECTOR_SOURCE);
            else if (staticConfig.isFederated) sourceType = (0, $aoy1P.FEDERATED_CONNECTOR_SOURCE);
            else sourceType = (0, $aoy1P.FULL_CONNECTOR_SOURCE);
            connectorSourceMap.set(providerId, (connectorSourceMap.get(providerId) || new Set()).add(sourceType));
            const existingConfig = thirdPartyConfigsWithAPIResponse[productKey];
            const isExistingConfigFullConnectorSource = existingConfig?.connectorSources?.includes((0, $aoy1P.FULL_CONNECTOR_SOURCE)) || false;
            const outboundAuthUrl = isFederatedNoOAuthConnector ? '' : isExistingConfigFullConnectorSource && existingConfig?.outboundAuthUrl ? existingConfig.outboundAuthUrl : resource.outboundAuthUrl;
            const userNeedsOAuth = isFederatedNoOAuthConnector ? false : isExistingConfigFullConnectorSource && existingConfig ? existingConfig.userNeedsOAuth : !resource.isUserOAuthed;
            config = {
                ...staticConfig,
                outboundAuthUrl: outboundAuthUrl,
                userNeedsOAuth: userNeedsOAuth,
                providerId: providerId,
                datasourceId: datasourceId,
                connectionId: resource.connectionId,
                workspaceName: resource.workspaceName,
                workspaceUrl: resource.workspaceUrl,
                connectorSources: Array.from(connectorSourceMap.get(providerId) || []),
                impersonationEnabled: resource.isImpersonationAuthEnabled,
                authResolutionMode: resource.authResolutionMode
            };
            const datasourceList = [];
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { datasources: datasources, ...configWithoutDatasources } = config;
            configWithoutDatasources.datasourceId = resource.datasourceId;
            configWithoutDatasources.connectionId = resource.connectionId;
            const datasource = {
                ...configWithoutDatasources,
                ...resource,
                outboundAuthUrl: isFederatedNoOAuthConnector ? '' : resource.outboundAuthUrl,
                userNeedsOAuth: isFederatedNoOAuthConnector ? false : !resource.isUserOAuthed,
                integrationAri: resource.integrationId || configWithoutDatasources.integrationAri
            };
            datasourceList.push(datasource);
            const extraDatasources = thirdPartyConfigsWithAPIResponse[productKey]?.datasources || [];
            const cleanedExtraDatasources = extraDatasources.map(// eslint-disable-next-line @typescript-eslint/no-unused-vars
            ({ datasources: datasources, ...configWithoutDatasources })=>configWithoutDatasources);
            datasourceList.push(...cleanedExtraDatasources);
            config.datasources = datasourceList;
            thirdPartyConfigsWithAPIResponse[productKey] = config;
        }
    }
    const filteredProductKeys = productKeys.filter((productKey)=>{
        if ((0, $aoy1P.isForgeConnectorProductKey)(productKey)) return true;
        return $b217d7e94854b92c$var$allProductKeys.includes(productKey);
    });
    return {
        productKeys: filteredProductKeys,
        thirdPartyConfigs: thirdPartyConfigsWithAPIResponse
    };
};
const $b217d7e94854b92c$var$EMPTY_RESPONSE = [];
const $b217d7e94854b92c$export$4fc2f66fb6e9d067 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { cloudId: cloudId, absoluteUrl: absoluteUrl, userId: userId, disabled: disabled, experience: experience, analytics: analytics } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[0] = t1;
    } else t1 = $[0];
    const [config, setConfig] = (0, $cozmU.useState)(t1);
    const { fireAnalyticsEvent: fireAnalyticsEvent, logException: logException, searchSessionId: searchSessionId, source: source, actionSubject: actionSubject, taskNamePrefix: taskNamePrefix, createNetworkCallbacks: createNetworkCallbacks } = analytics;
    let t2;
    if ($[1] !== absoluteUrl || $[2] !== actionSubject || $[3] !== cloudId || $[4] !== config.productKeys || $[5] !== createNetworkCallbacks || $[6] !== disabled || $[7] !== experience || $[8] !== fireAnalyticsEvent || $[9] !== logException || $[10] !== searchSessionId || $[11] !== source || $[12] !== taskNamePrefix || $[13] !== userId) {
        t2 = ()=>{
            if (!config.productKeys) {
                if (!disabled && cloudId) {
                    const taskStartAt = performance.now();
                    const taskId = crypto.randomUUID();
                    fireAnalyticsEvent((0, $3eS8z.onTaskStart)({
                        searchSessionId: searchSessionId,
                        taskId: taskId,
                        task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_UX),
                        moreContext: {
                            experience: experience
                        }
                    }));
                    const networkCallbacks = createNetworkCallbacks ? createNetworkCallbacks(taskId, (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_NETWORK), searchSessionId, fireAnalyticsEvent, taskStartAt, {
                        experience: experience
                    }) : undefined;
                    const degradationCallback = (reason)=>{
                        fireAnalyticsEvent((0, $3eS8z.onDegradedDependency)({
                            dependency: "search-3p-config",
                            searchSessionId: searchSessionId,
                            reason: reason,
                            source: source,
                            actionSubject: actionSubject
                        }));
                    };
                    const cacheAnalyticsCallback = async (state)=>{
                        fireAnalyticsEvent((0, $3eS8z.onRequestCacheAccess)({
                            requestName: "search-3p-config",
                            searchSessionId: searchSessionId,
                            cacheHit: state.hit,
                            refreshTriggered: state.refreshTriggered,
                            source: source,
                            actionSubject: actionSubject
                        }));
                    };
                    $b217d7e94854b92c$export$b58c1135b7f9df6d({
                        cloudId: cloudId,
                        absoluteUrl: absoluteUrl,
                        userId: userId,
                        degradationCallback: degradationCallback,
                        cacheAnalyticsCallback: cacheAnalyticsCallback,
                        networkCallbacks: networkCallbacks
                    }).then((data)=>{
                        setConfig({
                            productKeys: data.productKeys,
                            thirdPartyConfigs: data.thirdPartyConfigs
                        });
                        fireAnalyticsEvent((0, $3eS8z.onTaskSuccess)({
                            searchSessionId: searchSessionId,
                            taskId: taskId,
                            task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_UX),
                            moreContext: {
                                timeTaken: performance.now() - taskStartAt,
                                experience: experience
                            }
                        }));
                    }).catch((error)=>{
                        fireAnalyticsEvent((0, $3eS8z.onFailedDependency)({
                            dependency: "search-3p-config",
                            searchSessionId: searchSessionId,
                            source: source,
                            actionSubject: actionSubject
                        }));
                        fireAnalyticsEvent((0, $3eS8z.onTaskFail)({
                            searchSessionId: searchSessionId,
                            taskId: taskId,
                            task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_UX),
                            moreContext: {
                                error: error.name,
                                timeTaken: performance.now() - taskStartAt,
                                experience: experience
                            }
                        }));
                        setConfig({
                            productKeys: $b217d7e94854b92c$var$EMPTY_RESPONSE,
                            thirdPartyConfigs: {}
                        });
                        logException(error);
                    });
                } else setConfig({
                    productKeys: $b217d7e94854b92c$var$EMPTY_RESPONSE,
                    thirdPartyConfigs: {}
                });
            }
        };
        $[1] = absoluteUrl;
        $[2] = actionSubject;
        $[3] = cloudId;
        $[4] = config.productKeys;
        $[5] = createNetworkCallbacks;
        $[6] = disabled;
        $[7] = experience;
        $[8] = fireAnalyticsEvent;
        $[9] = logException;
        $[10] = searchSessionId;
        $[11] = source;
        $[12] = taskNamePrefix;
        $[13] = userId;
        $[14] = t2;
    } else t2 = $[14];
    let t3;
    if ($[15] !== absoluteUrl || $[16] !== actionSubject || $[17] !== cloudId || $[18] !== config || $[19] !== createNetworkCallbacks || $[20] !== disabled || $[21] !== experience || $[22] !== fireAnalyticsEvent || $[23] !== logException || $[24] !== searchSessionId || $[25] !== source || $[26] !== taskNamePrefix || $[27] !== userId) {
        t3 = [
            cloudId,
            absoluteUrl,
            userId,
            disabled,
            config,
            logException,
            fireAnalyticsEvent,
            searchSessionId,
            source,
            actionSubject,
            taskNamePrefix,
            createNetworkCallbacks,
            experience
        ];
        $[15] = absoluteUrl;
        $[16] = actionSubject;
        $[17] = cloudId;
        $[18] = config;
        $[19] = createNetworkCallbacks;
        $[20] = disabled;
        $[21] = experience;
        $[22] = fireAnalyticsEvent;
        $[23] = logException;
        $[24] = searchSessionId;
        $[25] = source;
        $[26] = taskNamePrefix;
        $[27] = userId;
        $[28] = t3;
    } else t3 = $[28];
    (0, $cozmU.useEffect)(t2, t3);
    return config;
} : ({ cloudId: cloudId, absoluteUrl: absoluteUrl, userId: userId, disabled: disabled, experience: experience, analytics: analytics })=>{
    const [config, setConfig] = (0, $cozmU.useState)({});
    const { fireAnalyticsEvent: fireAnalyticsEvent, logException: logException, searchSessionId: searchSessionId, source: source, actionSubject: actionSubject, taskNamePrefix: taskNamePrefix, createNetworkCallbacks: createNetworkCallbacks } = analytics;
    (0, $cozmU.useEffect)(()=>{
        if (!config.productKeys) {
            if (!disabled && cloudId) {
                const taskStartAt = performance.now();
                const taskId = crypto.randomUUID();
                fireAnalyticsEvent((0, $3eS8z.onTaskStart)({
                    searchSessionId: searchSessionId,
                    taskId: taskId,
                    task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_UX),
                    moreContext: {
                        experience: experience
                    }
                }));
                const networkCallbacks = createNetworkCallbacks ? createNetworkCallbacks(taskId, (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_NETWORK), searchSessionId, fireAnalyticsEvent, taskStartAt, {
                    experience: experience
                }) : undefined;
                const degradationCallback = (reason)=>{
                    fireAnalyticsEvent((0, $3eS8z.onDegradedDependency)({
                        dependency: 'search-3p-config',
                        searchSessionId: searchSessionId,
                        reason: reason,
                        source: source,
                        actionSubject: actionSubject
                    }));
                };
                const cacheAnalyticsCallback = async (state)=>{
                    fireAnalyticsEvent((0, $3eS8z.onRequestCacheAccess)({
                        requestName: 'search-3p-config',
                        searchSessionId: searchSessionId,
                        cacheHit: state.hit,
                        refreshTriggered: state.refreshTriggered,
                        source: source,
                        actionSubject: actionSubject
                    }));
                };
                $b217d7e94854b92c$export$b58c1135b7f9df6d({
                    cloudId: cloudId,
                    absoluteUrl: absoluteUrl,
                    userId: userId,
                    degradationCallback: degradationCallback,
                    cacheAnalyticsCallback: cacheAnalyticsCallback,
                    networkCallbacks: networkCallbacks
                }).then((data)=>{
                    setConfig({
                        productKeys: data.productKeys,
                        thirdPartyConfigs: data.thirdPartyConfigs
                    });
                    fireAnalyticsEvent((0, $3eS8z.onTaskSuccess)({
                        searchSessionId: searchSessionId,
                        taskId: taskId,
                        task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_UX),
                        moreContext: {
                            timeTaken: performance.now() - taskStartAt,
                            experience: experience
                        }
                    }));
                }).catch((error)=>{
                    fireAnalyticsEvent((0, $3eS8z.onFailedDependency)({
                        dependency: 'search-3p-config',
                        searchSessionId: searchSessionId,
                        source: source,
                        actionSubject: actionSubject
                    }));
                    fireAnalyticsEvent((0, $3eS8z.onTaskFail)({
                        searchSessionId: searchSessionId,
                        taskId: taskId,
                        task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_UX),
                        moreContext: {
                            error: error.name,
                            timeTaken: performance.now() - taskStartAt,
                            experience: experience
                        }
                    }));
                    setConfig({
                        productKeys: $b217d7e94854b92c$var$EMPTY_RESPONSE,
                        thirdPartyConfigs: {}
                    });
                    logException(error);
                });
            } else setConfig({
                productKeys: $b217d7e94854b92c$var$EMPTY_RESPONSE,
                thirdPartyConfigs: {}
            });
        }
    }, [
        cloudId,
        absoluteUrl,
        userId,
        disabled,
        config,
        logException,
        fireAnalyticsEvent,
        searchSessionId,
        source,
        actionSubject,
        taskNamePrefix,
        createNetworkCallbacks,
        experience
    ]);
    return config;
};
function $b217d7e94854b92c$var$_temp(edge) {
    return edge.node.id;
}
function $b217d7e94854b92c$var$_temp2(resource) {
    const { id: id } = resource;
    const match = id.match($b217d7e94854b92c$var$EXTRACT_PRODUCT);
    if (match && match.length >= 2) {
        const normalizedProduct = $b217d7e94854b92c$var$normalizeProductFromAri(match[1]);
        if ((0, $aqAfG.ARI_EXTRACTED_1P_KEYS).includes(normalizedProduct)) return [
            normalizedProduct
        ];
        if (normalizedProduct === (0, $fR63l.ProductKeys3P).Loom) return [
            normalizedProduct
        ];
    }
    return [];
}
function $b217d7e94854b92c$var$_temp3(resource_0) {
    const { id: id_0 } = resource_0;
    const match_0 = id_0.match($b217d7e94854b92c$var$EXTRACT_PRODUCT);
    if (match_0 && match_0.length >= 2 && match_0[1] in $b217d7e94854b92c$var$supportedNouns) return [
        match_0[1]
    ];
    return [];
}
function $b217d7e94854b92c$var$_temp4(r) {
    return r.id.includes($b217d7e94854b92c$var$BITBUCKET_WORKSPACE_ARI);
}
function $b217d7e94854b92c$var$_temp5(product) {
    return product !== (0, $aqAfG.ProductKeys1P).Bitbucket;
}
module.exports["useFetchConfig"] = $b217d7e94854b92c$export$2b0ac18f7cd43e19;
module.exports["useThirdPartyConfig"] = $b217d7e94854b92c$export$4fc2f66fb6e9d067;
module.exports["getThirdPartyTypes"] = $b217d7e94854b92c$export$6750011b01164bda;
module.exports["get3pProductKeys"] = $b217d7e94854b92c$export$b58c1135b7f9df6d;

});

parcelRegister("i9pyX", function(module, exports) {

var $gABt9 = parcelRequire("gABt9");


var $bZF61 = parcelRequire("bZF61");


var $fyjce = parcelRequire("fyjce");


var $9C63M = parcelRequire("9C63M");


var $bfpjP = parcelRequire("bfpjP");


var $d9nAp = parcelRequire("d9nAp");

const $c1ab7bf16286d454$var$RELATIVE_URL = '/gateway/api/xpsearch-aggregator/configuration/v1';
const $c1ab7bf16286d454$var$RELATIVE_URL_V2 = '/gateway/api/xpsearch-aggregator/api/v2/configuration';
const $c1ab7bf16286d454$var$RELATIVE_3P_URL = '/gateway/api/third-party-configuration/connected-data-sources';
const $c1ab7bf16286d454$var$RELATIVE_LOOM_AUTH_URL = '/gateway/api/loom-auth/api/internal/identity/user-status';
const $c1ab7bf16286d454$export$19524a749d98a458 = 'search-config';
const $c1ab7bf16286d454$export$cf95148f36a28b96 = 'search-3p-config';
const $c1ab7bf16286d454$export$44d1e7c4ef26c467 = 'loom-user-auth';
const { refreshOnAccessDecorator: $c1ab7bf16286d454$var$refreshOnAccessDecoratorSearch } = (0, $fyjce.promiseCache)({
    name: $c1ab7bf16286d454$export$19524a749d98a458
});
const { refreshOnAccessDecorator: $c1ab7bf16286d454$var$refreshOnAccessDecorator3pSearch, update: $c1ab7bf16286d454$var$update3pCache } = (0, $fyjce.promiseCache)({
    name: $c1ab7bf16286d454$export$cf95148f36a28b96,
    expiration: 300000
});
const { refreshOnAccessDecorator: $c1ab7bf16286d454$var$refreshOnAccessDecoratorUserLoomAuth } = (0, $fyjce.promiseCache)({
    name: $c1ab7bf16286d454$export$44d1e7c4ef26c467
});
const $c1ab7bf16286d454$var$SITELESS_PRODUCTS = [
    'trello',
    'bitbucket'
];
/**
 * Creates a traceInfoExtractor that reads from a mutable headers reference.
 * Used by REST config endpoints to extract requestId/traceId from HTTP response headers
 * without storing them in the cache.
 */ const $c1ab7bf16286d454$var$createTraceInfoExtractor = (headersRef)=>{
    return ()=>{
        const headers = headersRef();
        const requestId = headers['atl-request-id'];
        const traceId = headers['x-trace-id'];
        if (requestId || traceId) return {
            requestId: requestId,
            traceId: traceId
        };
        return undefined;
    };
};
const $c1ab7bf16286d454$export$2e9655e8b4177582 = async ({ absoluteUrl: absoluteUrl = '', hostName: hostName, cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration })=>{
    const url = absoluteUrl || `${hostName || ''}${$c1ab7bf16286d454$var$RELATIVE_URL}`;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $bZF61.generateHash)(`1p|${userId}|${cloudId}`);
    const supplier = ()=>(0, $gABt9.utils).requestService({
            url: url
        }, options).then((data)=>{
            const resources = data.resources.filter((resource)=>cloudId ? resource.id.includes(cloudId) || $c1ab7bf16286d454$var$SITELESS_PRODUCTS.find((product)=>resource.id.includes(product)) // Allow access to products that are not associated with a site
                 : true);
            return {
                resources: resources,
                intercomHmac: data.intercomHmac || '',
                siteMetadata: data.siteMetadata || []
            };
        });
    return $c1ab7bf16286d454$var$refreshOnAccessDecoratorSearch({
        key: key.toString(),
        supplier: supplier,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        serveResolvedDuringRefresh: true
    });
};
const $c1ab7bf16286d454$export$c6f4290269f11bd5 = async ({ absoluteUrl: absoluteUrl = '', hostName: hostName, cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, cacheAnalyticsCallback: cacheAnalyticsCallback, degradationCallback: degradationCallback = ()=>{}, returnExpired: returnExpired, networkCallbacks: networkCallbacks })=>{
    const url = absoluteUrl || `${hostName || ''}${$c1ab7bf16286d454$var$RELATIVE_URL_V2}/${cloudId}`;
    const queryParams = {
        operationName: 'searchPageFirstPartyConfig'
    };
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        },
        queryParams: queryParams
    };
    const key = (0, $bZF61.generateHash)(`1p|${userId}|${cloudId}|v2`);
    // Mutable reference for capturing tracing headers from the REST response.
    // Set by the supplier's reportTracingHeaders callback, read by traceInfoExtractor.
    // This avoids storing tracing headers in the cache — they're only used transiently for VitalStats events.
    let capturedTracingHeaders = {};
    const supplier = ()=>{
        capturedTracingHeaders = {};
        const searchConfigPromise = (0, $gABt9.utils).requestService({
            url: url
        }, {
            ...options,
            reportTracingHeaders: (headers)=>{
                capturedTracingHeaders = headers;
            }
        }).then((data)=>{
            return {
                resources: data.resources,
                intercomHmac: data.intercomHmac || '',
                siteMetadata: data.siteMetadata || []
            };
        });
        // Two cases here, due to the promiseCache from refreshOnAccessDecoratorSearch below
        // 1. Cache-miss: we of course want to handle degradation!
        // 2. Cache-hit: we actually still want to handle degradation, because if we can't refresh the cache due to a slow dependency, that is a signal we need in healthchecks
        // The alternate approach here would be to wrap the promiseCache in the DegradablePromise, but then we'd only get degradation pings on cache-miss.
        const degrader = new (0, $9C63M.DegradablePromise)(searchConfigPromise, degradationCallback);
        return degrader.promise();
    };
    const traceInfoExtractor = $c1ab7bf16286d454$var$createTraceInfoExtractor(()=>capturedTracingHeaders);
    return $c1ab7bf16286d454$var$refreshOnAccessDecoratorSearch({
        key: key.toString(),
        supplier: supplier,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        returnExpired: returnExpired,
        analyticsCallback: cacheAnalyticsCallback,
        networkCallbacks: networkCallbacks,
        serveResolvedDuringRefresh: true,
        traceInfoExtractor: traceInfoExtractor
    });
};
const $c1ab7bf16286d454$export$6916ea7f169882e0 = async ({ absoluteUrl: absoluteUrl = '', cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, cacheAnalyticsCallback: cacheAnalyticsCallback, degradationCallback: degradationCallback = ()=>{}, returnExpired: returnExpired, networkCallbacks: networkCallbacks })=>{
    const baseUrl = absoluteUrl || $c1ab7bf16286d454$var$RELATIVE_3P_URL;
    const url = `${baseUrl}/${cloudId}`;
    const queryParams = {
        operationName: 'searchPageThirdPartyConfig'
    };
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        },
        queryParams: queryParams
    };
    const key = (0, $d9nAp.generate3pHash)(userId || '', cloudId || '');
    // Mutable reference for capturing tracing headers from the REST response.
    // Set by the supplier's reportTracingHeaders callback, read by traceInfoExtractor.
    // This avoids storing tracing headers in the cache — they're only used transiently for VitalStats events.
    let capturedTracingHeaders = {};
    const supplier = ()=>{
        capturedTracingHeaders = {};
        const searchConfig3PPromise = (0, $gABt9.utils).requestService({
            url: url
        }, {
            ...options,
            reportTracingHeaders: (headers)=>{
                capturedTracingHeaders = headers;
            }
        });
        // Two cases here, due to the promiseCache from refreshOnAccessDecorator3pSearch below
        // 1. Cache-miss: we of course want to handle degradation!
        // 2. Cache-hit: we actually still want to handle degradation, because if we can't refresh the cache due to a slow dependency, that is a signal we need in healthchecks
        // The alternate approach here would be to wrap the promiseCache in the DegradablePromise, but then we'd only get degradation pings on cache-miss.
        const degrader = new (0, $9C63M.DegradablePromise)(searchConfig3PPromise, degradationCallback);
        return degrader.promise();
    };
    const traceInfoExtractor = $c1ab7bf16286d454$var$createTraceInfoExtractor(()=>capturedTracingHeaders);
    return $c1ab7bf16286d454$var$refreshOnAccessDecorator3pSearch({
        key: key.toString(),
        supplier: supplier,
        returnExpired: returnExpired,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        analyticsCallback: cacheAnalyticsCallback,
        networkCallbacks: networkCallbacks,
        serveResolvedDuringRefresh: true,
        traceInfoExtractor: traceInfoExtractor
    });
};
const $c1ab7bf16286d454$export$b75556aa5958ec1f = (userId, cloudId, updater)=>{
    const key = (0, $d9nAp.generate3pHash)(userId, cloudId);
    return $c1ab7bf16286d454$var$update3pCache(key.toString(), updater);
};
const $c1ab7bf16286d454$export$46e3d34ee7b8c58a = async ({ cloudId: cloudId, userId: userId })=>{
    const url = $c1ab7bf16286d454$var$RELATIVE_LOOM_AUTH_URL;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $bfpjP.generateLoomAuthHash)(userId || '', cloudId || '');
    const supplier = ()=>(0, $gABt9.utils).requestService({
            url: url
        }, options);
    return $c1ab7bf16286d454$var$refreshOnAccessDecoratorUserLoomAuth({
        key: key.toString(),
        supplier: supplier,
        returnExpired: false
    });
};
module.exports["getSearchConfigV2"] = $c1ab7bf16286d454$export$c6f4290269f11bd5;
module.exports["get3pSearchConfig"] = $c1ab7bf16286d454$export$6916ea7f169882e0;
module.exports["update3pConfigCacheEntry"] = $c1ab7bf16286d454$export$b75556aa5958ec1f;
module.exports["getUserLoomAuthStatus"] = $c1ab7bf16286d454$export$46e3d34ee7b8c58a;

});

parcelRegister("bfpjP", function(module, exports) {

var $bZF61 = parcelRequire("bZF61");

const $413fa6e1c2c21add$export$42b67d93e908c9dc = (userId, cloudId)=>(0, $bZF61.generateHash)(`loom|${userId}|${cloudId}`);
module.exports["generateLoomAuthHash"] = $413fa6e1c2c21add$export$42b67d93e908c9dc;

});

parcelRegister("d9nAp", function(module, exports) {

var $bZF61 = parcelRequire("bZF61");

const $de62146c16c69af1$export$f80795c7fd0ce9fc = (userId, cloudId)=>(0, $bZF61.generateHash)(`3p|${userId}|${cloudId}`);
module.exports["generate3pHash"] = $de62146c16c69af1$export$f80795c7fd0ce9fc;

});

parcelRegister("33u17", function(module, exports) {
const $ae48cc92829f03f8$export$37c9c6a3ae5f363c = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isJiraIssueIndexed;
};
module.exports["getJiraIssueIndexedForTenant"] = $ae48cc92829f03f8$export$37c9c6a3ae5f363c;

});

parcelRegister("fIdaz", function(module, exports) {
const $4db360da15a65550$export$c635d3296555e2da = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productDataRegions)?.productDataRegions;
};
module.exports["getProductDataRegions"] = $4db360da15a65550$export$c635d3296555e2da;

});

parcelRegister("lG3cK", function(module, exports) {
const $66c890b711298d6f$export$53e066a63a960439 = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productEdition)?.productEdition;
};
module.exports["getProductEdition"] = $66c890b711298d6f$export$53e066a63a960439;

});

parcelRegister("23xJD", function(module, exports) {
const $1278134308bb68fc$export$2a1c0662041ee0a3 = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.rovoFeatures)?.rovoFeatures;
};
module.exports["getRovoFeatures"] = $1278134308bb68fc$export$2a1c0662041ee0a3;

});

parcelRegister("0SpY7", function(module, exports) {
const $ab9de293bd9af112$export$7693a3bd75b4a085 = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isNounsAvailable;
};
module.exports["isNounsAvailable"] = $ab9de293bd9af112$export$7693a3bd75b4a085;

});

parcelRegister("lKvkH", function(module, exports) {
const $b8f211e3fef74233$export$243c13f4da40a98e = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isRovoEnabled;
};
module.exports["isRovoEnabled"] = $b8f211e3fef74233$export$243c13f4da40a98e;

});

parcelRegister("d396o", function(module, exports) {
/**
 * Primary product keys represent products that can mount Search Page.
 */ const $006726c89d71ae03$export$15d12effc8830544 = {
    Atlas: 'townsquare',
    Confluence: 'confluence',
    Assets: 'cmdb',
    Focus: 'mercury',
    Jira: 'jira',
    Elevate: 'elevate',
    Talent: 'radar',
    RovoExtension: 'rovo-extension',
    Studio: 'studio',
    Loom: 'loom'
};
module.exports["PrimaryProductKeys"] = $006726c89d71ae03$export$15d12effc8830544;

});

parcelRegister("5OPAY", function(module, exports) {






const $4d92eafc5833ccdb$var$EXTRACT_CLOUD_ID = /ari:cloud:.*?\/(.*)/;
const $4d92eafc5833ccdb$export$c1871fdf674a03c4 = (firstPartyResponse)=>{
    const match = firstPartyResponse.resources[0]?.id.match($4d92eafc5833ccdb$var$EXTRACT_CLOUD_ID);
    const extractedCloudId = match ? match[1] : '';
    return extractedCloudId;
};
module.exports["getFirstCloudId"] = $4d92eafc5833ccdb$export$c1871fdf674a03c4;

});

parcelRegister("dAuCI", function(module, exports) {

var $fR63l = parcelRequire("fR63l");


class $a264614d865c7774$export$50e7f6c2eabc665 {
    /**
   * Returns the number of registered configs.
   */ get size() {
        return this.factories.size;
    }
    /**
   * Checks whether a config is registered for the given key.
   */ has(key) {
        return this.factories.has(key);
    }
    /**
   * Returns all registered product keys synchronously.
   */ keys() {
        return Array.from(this.factories.keys());
    }
    /**
   * Asynchronously retrieves a single config by key.
   * The config module is loaded on first access and cached thereafter.
   */ async get(key) {
        if (this.cache.has(key)) return this.cache.get(key);
        const factory = this.factories.get(key);
        if (!factory) return undefined;
        const config = await factory();
        this.cache.set(key, config);
        return config;
    }
    /**
   * Asynchronously iterates over all entries, invoking the callback for each.
   * Each config is lazily loaded as the iteration reaches it.
   */ async forEach(callbackfn) {
        for (const key of this.factories.keys()){
            const config = await this.get(key);
            if (config) await callbackfn(config, key);
        }
    }
    /**
   * Async generator that yields [key, config] entries lazily.
   */ async *entries() {
        for (const key of this.factories.keys()){
            const config = await this.get(key);
            if (config) yield [
                key,
                config
            ];
        }
    }
    /**
   * Async generator that yields config values lazily.
   */ async *values() {
        for (const key of this.factories.keys()){
            const config = await this.get(key);
            if (config) yield config;
        }
    }
    /**
   * Resolves all configs and returns them as a standard Map.
   * Useful when all configs are needed at once.
   */ async getAll() {
        const result = new Map();
        for (const key of this.factories.keys()){
            const config = await this.get(key);
            if (config) result.set(key, config);
        }
        return result;
    }
    constructor(entries){
        this.factories = void 0;
        this.cache = new Map();
        this.factories = new Map(entries);
    }
}

































































































































































































const $a264614d865c7774$export$f7937c5f282f2571 = new $a264614d865c7774$export$50e7f6c2eabc665([
    [
        (0, $fR63l.ProductKeys3P).AtlassianWebCrawler,
        ()=>(parcelRequire("iBxe8")).then((m)=>m.atlassianWebCrawlerConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Figma,
        ()=>(parcelRequire("gT6ig")).then((m)=>m.figmaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Github,
        ()=>(parcelRequire("ctb8J")).then((m)=>m.githubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleDrive,
        ()=>(parcelRequire("aBc9a")).then((m)=>m.googleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sharepoint,
        ()=>(parcelRequire("gPij5")).then((m)=>m.sharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Loom,
        ()=>(parcelRequire("amX3I")).then((m)=>m.loomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OneDrive,
        ()=>(parcelRequire("6GYA1")).then((m)=>m.oneDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dropbox,
        ()=>(parcelRequire("62RGF")).then((m)=>m.dropboxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Slack,
        ()=>(parcelRequire("df2sa")).then((m)=>m.slackConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Teams,
        ()=>(parcelRequire("TPBVI")).then((m)=>m.teamsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleCalendar,
        ()=>(parcelRequire("1EmMA")).then((m)=>m.googleCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gmail,
        ()=>(parcelRequire("gsNVH")).then((m)=>m.gmailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookCalendar,
        ()=>(parcelRequire("lr0CG")).then((m)=>m.outlookCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookMail,
        ()=>(parcelRequire("83jvW")).then((m)=>m.outlookMail)
    ],
    [
        (0, $fR63l.ProductKeys3P).Asana,
        ()=>(parcelRequire("aMNB6")).then((m)=>m.asanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zendesk,
        ()=>(parcelRequire("74xIl")).then((m)=>m.zendeskConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Airtable,
        ()=>(parcelRequire("8Vszy")).then((m)=>m.airtableConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Smartsheet,
        ()=>(parcelRequire("b22hO")).then((m)=>m.smartsheetConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Notion,
        ()=>(parcelRequire("cEdIY")).then((m)=>m.notionConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Miro,
        ()=>(parcelRequire("31RHj")).then((m)=>m.miroConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Docusign,
        ()=>(parcelRequire("02Ynr")).then((m)=>m.docusignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Lucid,
        ()=>(parcelRequire("fwd4N")).then((m)=>m.lucidConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Monday,
        ()=>(parcelRequire("2RnL3")).then((m)=>m.mondayConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AzureDevops,
        ()=>(parcelRequire("58OWX")).then((m)=>m.azureDevopsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitlab,
        ()=>(parcelRequire("kL104")).then((m)=>m.gitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ConfluenceDC,
        ()=>(parcelRequire("l2ij3")).then((m)=>m.confluenceDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JiraDC,
        ()=>(parcelRequire("fCWIf")).then((m)=>m.jiraDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JsmDC,
        ()=>(parcelRequire("cTBjV")).then((m)=>m.jsmDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Canva,
        ()=>(parcelRequire("3QlPK")).then((m)=>m.canvaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Box,
        ()=>(parcelRequire("hElI5")).then((m)=>m.boxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zoom,
        ()=>(parcelRequire("a5g8K")).then((m)=>m.zoomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zeplin,
        ()=>(parcelRequire("bgwDS")).then((m)=>m.zeplinConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ServiceNow,
        ()=>(parcelRequire("lAH85")).then((m)=>m.serviceNowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Freshservice,
        ()=>(parcelRequire("iKBOF")).then((m)=>m.freshserviceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PowerBI,
        ()=>(parcelRequire("5pBM8")).then((m)=>m.powerBIConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ClickUp,
        ()=>(parcelRequire("92ME9")).then((m)=>m.clickUpConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Amplitude,
        ()=>(parcelRequire("6Jh1p")).then((m)=>m.amplitudeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Stripe,
        ()=>(parcelRequire("jzPn4")).then((m)=>m.stripeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeXD,
        ()=>(parcelRequire("kZqu6")).then((m)=>m.adobeXDConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Aha,
        ()=>(parcelRequire("ajtDF")).then((m)=>m.ahaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeSign,
        ()=>(parcelRequire("fKfb7")).then((m)=>m.adobeSignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Mural,
        ()=>(parcelRequire("hXJgg")).then((m)=>m.muralConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Webex,
        ()=>(parcelRequire("hhNgf")).then((m)=>m.webexConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Todoist,
        ()=>(parcelRequire("crz44")).then((m)=>m.todoistConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PagerDuty,
        ()=>(parcelRequire("3Igok")).then((m)=>m.pagerDutyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Pipedrive,
        ()=>(parcelRequire("cz85h")).then((m)=>m.pipedriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Hubspot,
        ()=>(parcelRequire("dvJin")).then((m)=>m.hubSpotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dovetail,
        ()=>(parcelRequire("7Mz2I")).then((m)=>m.dovetailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).LaunchDarkly,
        ()=>(parcelRequire("aiSZX")).then((m)=>m.launchDarklyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Salesforce,
        ()=>(parcelRequire("9EADZ")).then((m)=>m.salesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sentry,
        ()=>(parcelRequire("8PK6n")).then((m)=>m.sentryConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitbook,
        ()=>(parcelRequire("jctME")).then((m)=>m.gitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AWSS3,
        ()=>(parcelRequire("bR0Iu")).then((m)=>m.awss3Config)
    ],
    [
        (0, $fR63l.ProductKeys3P).Databricks,
        ()=>(parcelRequire("3jXBQ")).then((m)=>m.databricksConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqDev,
        ()=>(parcelRequire("bAiH4")).then((m)=>m.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqProd,
        ()=>(parcelRequire("1xgz2")).then((m)=>m.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesDev,
        ()=>(parcelRequire("4RPDt")).then((m)=>m.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesProd,
        ()=>(parcelRequire("fsXZE")).then((m)=>m.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsDev,
        ()=>(parcelRequire("9aDYK")).then((m)=>m.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsProd,
        ()=>(parcelRequire("6JW0P")).then((m)=>m.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupDev,
        ()=>(parcelRequire("Uh4Xn")).then((m)=>m.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupProd,
        ()=>(parcelRequire("jirMU")).then((m)=>m.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookDev,
        ()=>(parcelRequire("lemnx")).then((m)=>m.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookProd,
        ()=>(parcelRequire("dzON5")).then((m)=>m.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubDev,
        ()=>(parcelRequire("bhHm2")).then((m)=>m.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubProd,
        ()=>(parcelRequire("cpHnm")).then((m)=>m.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabDev,
        ()=>(parcelRequire("kdTUL")).then((m)=>m.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabProd,
        ()=>(parcelRequire("2ixRt")).then((m)=>m.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveDev,
        ()=>(parcelRequire("41BIu")).then((m)=>m.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveProd,
        ()=>(parcelRequire("6s4rU")).then((m)=>m.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruDev,
        ()=>(parcelRequire("6KzzT")).then((m)=>m.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruProd,
        ()=>(parcelRequire("9DwSf")).then((m)=>m.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceDev,
        ()=>(parcelRequire("gxp6w")).then((m)=>m.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceProd,
        ()=>(parcelRequire("aYbsr")).then((m)=>m.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotDev,
        ()=>(parcelRequire("acx6k")).then((m)=>m.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotProd,
        ()=>(parcelRequire("iWCTF")).then((m)=>m.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceDev,
        ()=>(parcelRequire("2tWj9")).then((m)=>m.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceProd,
        ()=>(parcelRequire("arh0c")).then((m)=>m.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointDev,
        ()=>(parcelRequire("fb826")).then((m)=>m.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointProd,
        ()=>(parcelRequire("iO6my")).then((m)=>m.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowDev,
        ()=>(parcelRequire("cXcSd")).then((m)=>m.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowProd,
        ()=>(parcelRequire("bIQJz")).then((m)=>m.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookDev,
        ()=>(parcelRequire("8ILPc")).then((m)=>m.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookProd,
        ()=>(parcelRequire("hUid6")).then((m)=>m.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestDev,
        ()=>(parcelRequire("4ZlVU")).then((m)=>m.forgeGdriveEugeneTestDevConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestProd,
        ()=>(parcelRequire("ft0CM")).then((m)=>m.forgeGdriveEugeneTestProdConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceDev,
        ()=>(parcelRequire("4EGFU")).then((m)=>m.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceProd,
        ()=>(parcelRequire("hJUgO")).then((m)=>m.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowDev,
        ()=>(parcelRequire("26Y6c")).then((m)=>m.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowProd,
        ()=>(parcelRequire("k2jJ5")).then((m)=>m.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeDev,
        ()=>(parcelRequire("8t1lq")).then((m)=>m.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeProd,
        ()=>(parcelRequire("9uiEL")).then((m)=>m.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaDev,
        ()=>(parcelRequire("lghtg")).then((m)=>m.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaProd,
        ()=>(parcelRequire("3qEIn")).then((m)=>m.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampDev,
        ()=>(parcelRequire("fbkFk")).then((m)=>m.forgeUnitoBasecampConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampProd,
        ()=>(parcelRequire("lcUNq")).then((m)=>m.forgeUnitoBasecampConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AtlassianWebCrawler,
        ()=>(parcelRequire("iBxe8")).then((m)=>m.atlassianWebCrawlerConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Figma,
        ()=>(parcelRequire("gT6ig")).then((m)=>m.figmaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Github,
        ()=>(parcelRequire("ctb8J")).then((m)=>m.githubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleDrive,
        ()=>(parcelRequire("aBc9a")).then((m)=>m.googleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sharepoint,
        ()=>(parcelRequire("gPij5")).then((m)=>m.sharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Loom,
        ()=>(parcelRequire("amX3I")).then((m)=>m.loomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OneDrive,
        ()=>(parcelRequire("6GYA1")).then((m)=>m.oneDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dropbox,
        ()=>(parcelRequire("62RGF")).then((m)=>m.dropboxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Slack,
        ()=>(parcelRequire("df2sa")).then((m)=>m.slackConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Teams,
        ()=>(parcelRequire("TPBVI")).then((m)=>m.teamsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleCalendar,
        ()=>(parcelRequire("1EmMA")).then((m)=>m.googleCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gmail,
        ()=>(parcelRequire("gsNVH")).then((m)=>m.gmailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookCalendar,
        ()=>(parcelRequire("lr0CG")).then((m)=>m.outlookCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookMail,
        ()=>(parcelRequire("83jvW")).then((m)=>m.outlookMail)
    ],
    [
        (0, $fR63l.ProductKeys3P).Asana,
        ()=>(parcelRequire("aMNB6")).then((m)=>m.asanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zendesk,
        ()=>(parcelRequire("74xIl")).then((m)=>m.zendeskConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Airtable,
        ()=>(parcelRequire("8Vszy")).then((m)=>m.airtableConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Smartsheet,
        ()=>(parcelRequire("b22hO")).then((m)=>m.smartsheetConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Notion,
        ()=>(parcelRequire("cEdIY")).then((m)=>m.notionConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Miro,
        ()=>(parcelRequire("31RHj")).then((m)=>m.miroConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Docusign,
        ()=>(parcelRequire("02Ynr")).then((m)=>m.docusignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Lucid,
        ()=>(parcelRequire("fwd4N")).then((m)=>m.lucidConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Monday,
        ()=>(parcelRequire("2RnL3")).then((m)=>m.mondayConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AzureDevops,
        ()=>(parcelRequire("58OWX")).then((m)=>m.azureDevopsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitlab,
        ()=>(parcelRequire("kL104")).then((m)=>m.gitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ConfluenceDC,
        ()=>(parcelRequire("l2ij3")).then((m)=>m.confluenceDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JiraDC,
        ()=>(parcelRequire("fCWIf")).then((m)=>m.jiraDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JsmDC,
        ()=>(parcelRequire("cTBjV")).then((m)=>m.jsmDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Canva,
        ()=>(parcelRequire("3QlPK")).then((m)=>m.canvaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Box,
        ()=>(parcelRequire("hElI5")).then((m)=>m.boxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gong,
        ()=>(parcelRequire("7isp4")).then((m)=>m.gongConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zoom,
        ()=>(parcelRequire("a5g8K")).then((m)=>m.zoomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zeplin,
        ()=>(parcelRequire("bgwDS")).then((m)=>m.zeplinConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ServiceNow,
        ()=>(parcelRequire("lAH85")).then((m)=>m.serviceNowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Freshservice,
        ()=>(parcelRequire("iKBOF")).then((m)=>m.freshserviceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PowerBI,
        ()=>(parcelRequire("5pBM8")).then((m)=>m.powerBIConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ClickUp,
        ()=>(parcelRequire("92ME9")).then((m)=>m.clickUpConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Amplitude,
        ()=>(parcelRequire("6Jh1p")).then((m)=>m.amplitudeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Stripe,
        ()=>(parcelRequire("jzPn4")).then((m)=>m.stripeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeXD,
        ()=>(parcelRequire("kZqu6")).then((m)=>m.adobeXDConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Aha,
        ()=>(parcelRequire("ajtDF")).then((m)=>m.ahaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeSign,
        ()=>(parcelRequire("fKfb7")).then((m)=>m.adobeSignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Mural,
        ()=>(parcelRequire("hXJgg")).then((m)=>m.muralConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Webex,
        ()=>(parcelRequire("hhNgf")).then((m)=>m.webexConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Todoist,
        ()=>(parcelRequire("crz44")).then((m)=>m.todoistConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PagerDuty,
        ()=>(parcelRequire("3Igok")).then((m)=>m.pagerDutyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Pipedrive,
        ()=>(parcelRequire("cz85h")).then((m)=>m.pipedriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Hubspot,
        ()=>(parcelRequire("dvJin")).then((m)=>m.hubSpotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dovetail,
        ()=>(parcelRequire("7Mz2I")).then((m)=>m.dovetailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).LaunchDarkly,
        ()=>(parcelRequire("aiSZX")).then((m)=>m.launchDarklyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Salesforce,
        ()=>(parcelRequire("9EADZ")).then((m)=>m.salesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sentry,
        ()=>(parcelRequire("8PK6n")).then((m)=>m.sentryConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitbook,
        ()=>(parcelRequire("jctME")).then((m)=>m.gitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AWSS3,
        ()=>(parcelRequire("bR0Iu")).then((m)=>m.awss3Config)
    ],
    [
        (0, $fR63l.ProductKeys3P).Databricks,
        ()=>(parcelRequire("3jXBQ")).then((m)=>m.databricksConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqDev,
        ()=>(parcelRequire("bAiH4")).then((m)=>m.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqProd,
        ()=>(parcelRequire("1xgz2")).then((m)=>m.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesDev,
        ()=>(parcelRequire("4RPDt")).then((m)=>m.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesProd,
        ()=>(parcelRequire("fsXZE")).then((m)=>m.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsDev,
        ()=>(parcelRequire("9aDYK")).then((m)=>m.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsProd,
        ()=>(parcelRequire("6JW0P")).then((m)=>m.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupDev,
        ()=>(parcelRequire("Uh4Xn")).then((m)=>m.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupProd,
        ()=>(parcelRequire("jirMU")).then((m)=>m.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookDev,
        ()=>(parcelRequire("lemnx")).then((m)=>m.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookProd,
        ()=>(parcelRequire("dzON5")).then((m)=>m.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubDev,
        ()=>(parcelRequire("bhHm2")).then((m)=>m.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubProd,
        ()=>(parcelRequire("cpHnm")).then((m)=>m.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabDev,
        ()=>(parcelRequire("kdTUL")).then((m)=>m.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabProd,
        ()=>(parcelRequire("2ixRt")).then((m)=>m.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveDev,
        ()=>(parcelRequire("41BIu")).then((m)=>m.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveProd,
        ()=>(parcelRequire("6s4rU")).then((m)=>m.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruDev,
        ()=>(parcelRequire("6KzzT")).then((m)=>m.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruProd,
        ()=>(parcelRequire("9DwSf")).then((m)=>m.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceDev,
        ()=>(parcelRequire("gxp6w")).then((m)=>m.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceProd,
        ()=>(parcelRequire("aYbsr")).then((m)=>m.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotDev,
        ()=>(parcelRequire("acx6k")).then((m)=>m.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotProd,
        ()=>(parcelRequire("iWCTF")).then((m)=>m.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceDev,
        ()=>(parcelRequire("2tWj9")).then((m)=>m.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceProd,
        ()=>(parcelRequire("arh0c")).then((m)=>m.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointDev,
        ()=>(parcelRequire("fb826")).then((m)=>m.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointProd,
        ()=>(parcelRequire("iO6my")).then((m)=>m.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowDev,
        ()=>(parcelRequire("cXcSd")).then((m)=>m.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowProd,
        ()=>(parcelRequire("bIQJz")).then((m)=>m.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookDev,
        ()=>(parcelRequire("8ILPc")).then((m)=>m.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookProd,
        ()=>(parcelRequire("hUid6")).then((m)=>m.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestDev,
        ()=>(parcelRequire("4ZlVU")).then((m)=>m.forgeGdriveEugeneTestDevConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestProd,
        ()=>(parcelRequire("ft0CM")).then((m)=>m.forgeGdriveEugeneTestProdConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceDev,
        ()=>(parcelRequire("4EGFU")).then((m)=>m.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceProd,
        ()=>(parcelRequire("hJUgO")).then((m)=>m.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowDev,
        ()=>(parcelRequire("26Y6c")).then((m)=>m.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowProd,
        ()=>(parcelRequire("k2jJ5")).then((m)=>m.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeDev,
        ()=>(parcelRequire("8t1lq")).then((m)=>m.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeProd,
        ()=>(parcelRequire("9uiEL")).then((m)=>m.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaDev,
        ()=>(parcelRequire("lghtg")).then((m)=>m.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaProd,
        ()=>(parcelRequire("3qEIn")).then((m)=>m.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampDev,
        ()=>(parcelRequire("fbkFk")).then((m)=>m.forgeUnitoBasecampConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampProd,
        ()=>(parcelRequire("lcUNq")).then((m)=>m.forgeUnitoBasecampConfig)
    ]
]);
const $a264614d865c7774$var$productKeys3PValues = new Set(Object.values((0, $fR63l.ProductKeys3P)));
const $a264614d865c7774$export$985cb3900add20c8 = (value)=>$a264614d865c7774$var$productKeys3PValues.has(value);
module.exports["ThirdPartyConfigs"] = $a264614d865c7774$export$f7937c5f282f2571;
module.exports["isProductKey3P"] = $a264614d865c7774$export$985cb3900add20c8;

});

parcelRegister("iBxe8", function(module, exports) {

let $d8b574e2a5cc37c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d8b574e2a5cc37c1$var$load("6wr18"),
    $d8b574e2a5cc37c1$var$load("ffEVr"),
    $d8b574e2a5cc37c1$var$load("bRtkB")
]).then(()=>parcelRequire('jAKKt'));

});

parcelRegister("gT6ig", function(module, exports) {

let $c4b6aa311ef513a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c4b6aa311ef513a4$var$load("aF2C4").then(()=>parcelRequire('7dzhu'));

});

parcelRegister("ctb8J", function(module, exports) {

let $9140d59f8ad886b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9140d59f8ad886b7$var$load("3eAWG").then(()=>parcelRequire('aZX0c'));

});

parcelRegister("aBc9a", function(module, exports) {

let $7b76c832d4976913$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7b76c832d4976913$var$load("1HPRy").then(()=>parcelRequire('kFYBW'));

});

parcelRegister("gPij5", function(module, exports) {

let $c3ff9c1894b5ec04$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c3ff9c1894b5ec04$var$load("7zQG2").then(()=>parcelRequire('gOrBS'));

});

parcelRegister("amX3I", function(module, exports) {

let $78c9c54f9e184906$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $78c9c54f9e184906$var$load("fdFOR").then(()=>parcelRequire('lSeWC'));

});

parcelRegister("6GYA1", function(module, exports) {

let $4df5a84501aea93d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4df5a84501aea93d$var$load("hUZCM").then(()=>parcelRequire('4TRyZ'));

});

parcelRegister("62RGF", function(module, exports) {

let $466c932715083697$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $466c932715083697$var$load("2zKe1").then(()=>parcelRequire('2qza4'));

});

parcelRegister("df2sa", function(module, exports) {

let $9a3e943c15d3b5a9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9a3e943c15d3b5a9$var$load("dgWVQ").then(()=>parcelRequire('kDG5l'));

});

parcelRegister("TPBVI", function(module, exports) {

let $0a7d2bfe5b7d495f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0a7d2bfe5b7d495f$var$load("3cJjP").then(()=>parcelRequire('6sCQO'));

});

parcelRegister("1EmMA", function(module, exports) {

let $133b3308a7233083$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $133b3308a7233083$var$load("RMzu0").then(()=>parcelRequire('6eg6r'));

});

parcelRegister("gsNVH", function(module, exports) {

let $bfc5fdd4fc7f4d22$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bfc5fdd4fc7f4d22$var$load("4ZzjZ").then(()=>parcelRequire('52jas'));

});

parcelRegister("lr0CG", function(module, exports) {

let $f9ac9a496374d705$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f9ac9a496374d705$var$load("k90dx").then(()=>parcelRequire('ijAga'));

});

parcelRegister("83jvW", function(module, exports) {

let $5dcdbda30e12c09c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5dcdbda30e12c09c$var$load("amIJr").then(()=>parcelRequire('dPp45'));

});

parcelRegister("aMNB6", function(module, exports) {

let $7da4dc18e877575a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7da4dc18e877575a$var$load("gguK2").then(()=>parcelRequire('4Be7r'));

});

parcelRegister("74xIl", function(module, exports) {

let $52630f17b0854dee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $52630f17b0854dee$var$load("hZzel").then(()=>parcelRequire('kmEEk'));

});

parcelRegister("8Vszy", function(module, exports) {

let $67f9cf78855bdd75$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $67f9cf78855bdd75$var$load("jTrn5").then(()=>parcelRequire('52Drw'));

});

parcelRegister("b22hO", function(module, exports) {

let $8081a799b789106b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8081a799b789106b$var$load("eOlJP").then(()=>parcelRequire('aaz0Y'));

});

parcelRegister("cEdIY", function(module, exports) {

let $9353ddd09a324ff5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9353ddd09a324ff5$var$load("3BeCY").then(()=>parcelRequire('kcCFv'));

});

parcelRegister("31RHj", function(module, exports) {

let $234b1e534467b651$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $234b1e534467b651$var$load("6b6gt").then(()=>parcelRequire('6lsSn'));

});

parcelRegister("02Ynr", function(module, exports) {

let $008f05a6f17f22ea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $008f05a6f17f22ea$var$load("407Jg").then(()=>parcelRequire('k521G'));

});

parcelRegister("fwd4N", function(module, exports) {

let $b4c3fcde50fe0553$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b4c3fcde50fe0553$var$load("63b2S").then(()=>parcelRequire('43W2t'));

});

parcelRegister("2RnL3", function(module, exports) {

let $2152f5d98da817b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2152f5d98da817b1$var$load("fJLp0").then(()=>parcelRequire('6ThsT'));

});

parcelRegister("58OWX", function(module, exports) {

let $3be538af45050ae5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3be538af45050ae5$var$load("bzCMM").then(()=>parcelRequire('4x6XK'));

});

parcelRegister("kL104", function(module, exports) {

let $f1c8f9056a588ec3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1c8f9056a588ec3$var$load("alsd0").then(()=>parcelRequire('382mb'));

});

parcelRegister("l2ij3", function(module, exports) {

let $f507fc2081146ddd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f507fc2081146ddd$var$load("7hrcy"),
    $f507fc2081146ddd$var$load("c3RBb"),
    $f507fc2081146ddd$var$load("jZNbu")
]).then(()=>parcelRequire('8oQ7k'));

});

parcelRegister("fCWIf", function(module, exports) {

let $b607f2b6fb44426b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b607f2b6fb44426b$var$load("7hrcy"),
    $b607f2b6fb44426b$var$load("c3RBb"),
    $b607f2b6fb44426b$var$load("cYv6T")
]).then(()=>parcelRequire('79ijY'));

});

parcelRegister("cTBjV", function(module, exports) {

let $963792230ce90974$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $963792230ce90974$var$load("9BBvG").then(()=>parcelRequire('e7BOf'));

});

parcelRegister("3QlPK", function(module, exports) {

let $2cc72a2827e9e607$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2cc72a2827e9e607$var$load("jRzSB").then(()=>parcelRequire('fg2gb'));

});

parcelRegister("hElI5", function(module, exports) {

let $cd9703462afb8136$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cd9703462afb8136$var$load("2MOvO").then(()=>parcelRequire('fauGM'));

});

parcelRegister("a5g8K", function(module, exports) {

let $7576e419eec1cb14$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7576e419eec1cb14$var$load("1Sqxt").then(()=>parcelRequire('bj13p'));

});

parcelRegister("bgwDS", function(module, exports) {

let $833a8266b04eb5a8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $833a8266b04eb5a8$var$load("11sVB").then(()=>parcelRequire('3VdqU'));

});

parcelRegister("lAH85", function(module, exports) {

let $fb7e6a65b66ccf78$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fb7e6a65b66ccf78$var$load("frCen").then(()=>parcelRequire('iN1Vs'));

});

parcelRegister("iKBOF", function(module, exports) {

let $da69db677e750701$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $da69db677e750701$var$load("22bew").then(()=>parcelRequire('fA9zj'));

});

parcelRegister("5pBM8", function(module, exports) {

let $3f0c96f8bef833fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3f0c96f8bef833fc$var$load("4NtL2").then(()=>parcelRequire('iTxTm'));

});

parcelRegister("92ME9", function(module, exports) {

let $695a0929d74d2f0e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $695a0929d74d2f0e$var$load("3peYA").then(()=>parcelRequire('5pWqV'));

});

parcelRegister("6Jh1p", function(module, exports) {

let $4e642630456ad387$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4e642630456ad387$var$load("DPLw5").then(()=>parcelRequire('juuLe'));

});

parcelRegister("jzPn4", function(module, exports) {

let $e409226bb43ffbc8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e409226bb43ffbc8$var$load("emPuN").then(()=>parcelRequire('3juV6'));

});

parcelRegister("kZqu6", function(module, exports) {

let $f47e0c6fe7314294$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f47e0c6fe7314294$var$load("a8X2u").then(()=>parcelRequire('hIDj1'));

});

parcelRegister("ajtDF", function(module, exports) {

let $7822ab60aaa856ca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7822ab60aaa856ca$var$load("39rcm").then(()=>parcelRequire('7WW80'));

});

parcelRegister("fKfb7", function(module, exports) {

let $b766ecf99dcb12e7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b766ecf99dcb12e7$var$load("6xDnX").then(()=>parcelRequire('au9jr'));

});

parcelRegister("hXJgg", function(module, exports) {

let $d13b0e50e5899a08$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d13b0e50e5899a08$var$load("bWrbO").then(()=>parcelRequire('diJOH'));

});

parcelRegister("hhNgf", function(module, exports) {

let $c95a3c704c7acf2e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c95a3c704c7acf2e$var$load("e2pEU").then(()=>parcelRequire('5bQLl'));

});

parcelRegister("crz44", function(module, exports) {

let $90f334c6140cf4a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $90f334c6140cf4a0$var$load("4s14m").then(()=>parcelRequire('dVIA3'));

});

parcelRegister("3Igok", function(module, exports) {

let $2b42321f56861e0b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2b42321f56861e0b$var$load("ake72").then(()=>parcelRequire('emznk'));

});

parcelRegister("cz85h", function(module, exports) {

let $925f063e9e60a948$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $925f063e9e60a948$var$load("icZ4h").then(()=>parcelRequire('fMCQp'));

});

parcelRegister("dvJin", function(module, exports) {

let $9d614e56edab5644$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9d614e56edab5644$var$load("ceQaW").then(()=>parcelRequire('cdiu6'));

});

parcelRegister("7Mz2I", function(module, exports) {

let $5aa832e47052f086$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5aa832e47052f086$var$load("lKvqu").then(()=>parcelRequire('8djpu'));

});

parcelRegister("aiSZX", function(module, exports) {

let $78063f56f0861dfa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $78063f56f0861dfa$var$load("6nEcR").then(()=>parcelRequire('3P9fk'));

});

parcelRegister("9EADZ", function(module, exports) {

let $707446315559077a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $707446315559077a$var$load("5d2zd").then(()=>parcelRequire('lPRuX'));

});

parcelRegister("8PK6n", function(module, exports) {

let $66e6d904c8677960$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $66e6d904c8677960$var$load("lmH6s").then(()=>parcelRequire('2zNcl'));

});

parcelRegister("jctME", function(module, exports) {

let $dfa63db87e8bb2b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dfa63db87e8bb2b1$var$load("h7ufj").then(()=>parcelRequire('h8Js2'));

});

parcelRegister("bR0Iu", function(module, exports) {

let $8a153339a5d5476b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8a153339a5d5476b$var$load("7ravW").then(()=>parcelRequire('9Om9G'));

});

parcelRegister("3jXBQ", function(module, exports) {

let $26b1629b18db5440$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $26b1629b18db5440$var$load("aZ5Xl").then(()=>parcelRequire('kiNtZ'));

});

parcelRegister("bAiH4", function(module, exports) {

let $86f18eac9cf3c96e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $86f18eac9cf3c96e$var$load("cTH3r").then(()=>parcelRequire('1RpaO'));

});

parcelRegister("1xgz2", function(module, exports) {

let $11e5b8d1886eee68$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $11e5b8d1886eee68$var$load("dne17").then(()=>parcelRequire('jENKA'));

});

parcelRegister("4RPDt", function(module, exports) {

let $38b42a6c124bdd71$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $38b42a6c124bdd71$var$load("cHAvQ").then(()=>parcelRequire('j34lg'));

});

parcelRegister("fsXZE", function(module, exports) {

let $b42801fc65ba38db$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b42801fc65ba38db$var$load("gpIIT").then(()=>parcelRequire('in2Pi'));

});

parcelRegister("9aDYK", function(module, exports) {

let $6ad40f2a8491628c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6ad40f2a8491628c$var$load("8qNIV").then(()=>parcelRequire('7vbr8'));

});

parcelRegister("6JW0P", function(module, exports) {

let $4e83f21bd16f4d79$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4e83f21bd16f4d79$var$load("701fE").then(()=>parcelRequire('k6vRK'));

});

parcelRegister("Uh4Xn", function(module, exports) {

let $0a927a99cc57cc79$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0a927a99cc57cc79$var$load("05bRk").then(()=>parcelRequire('aiL8h'));

});

parcelRegister("jirMU", function(module, exports) {

let $e0c540e00d23fa0c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e0c540e00d23fa0c$var$load("lnWlT").then(()=>parcelRequire('cY0ZT'));

});

parcelRegister("lemnx", function(module, exports) {

let $03fd19ddc4d2f4f5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $03fd19ddc4d2f4f5$var$load("jQK5h").then(()=>parcelRequire('9SYma'));

});

parcelRegister("dzON5", function(module, exports) {

let $9e25f13380966ec6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9e25f13380966ec6$var$load("kg1Ok").then(()=>parcelRequire('ie06K'));

});

parcelRegister("bhHm2", function(module, exports) {

let $8372e98813ff3fca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8372e98813ff3fca$var$load("kobFT").then(()=>parcelRequire('h5NUz'));

});

parcelRegister("cpHnm", function(module, exports) {

let $90997763425d308b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $90997763425d308b$var$load("bLIUJ").then(()=>parcelRequire('9Y160'));

});

parcelRegister("kdTUL", function(module, exports) {

let $eb906502f834c30e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eb906502f834c30e$var$load("cklhl").then(()=>parcelRequire('hdy05'));

});

parcelRegister("2ixRt", function(module, exports) {

let $1ac7876a9dbc87f3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1ac7876a9dbc87f3$var$load("2GC7K").then(()=>parcelRequire('djF8v'));

});

parcelRegister("41BIu", function(module, exports) {

let $2ee483264ab9d610$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2ee483264ab9d610$var$load("bD8in").then(()=>parcelRequire('dChew'));

});

parcelRegister("6s4rU", function(module, exports) {

let $4b28cf1866257ad5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4b28cf1866257ad5$var$load("gdVxH").then(()=>parcelRequire('TCovD'));

});

parcelRegister("6KzzT", function(module, exports) {

let $4ea2a2f6c2fe6e5a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ea2a2f6c2fe6e5a$var$load("7xK5Z").then(()=>parcelRequire('feDPe'));

});

parcelRegister("9DwSf", function(module, exports) {

let $704141aa2412a02b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $704141aa2412a02b$var$load("b4BtI").then(()=>parcelRequire('klS4t'));

});

parcelRegister("gxp6w", function(module, exports) {

let $c0a333981d8cd2fb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c0a333981d8cd2fb$var$load("iljFU").then(()=>parcelRequire('hFdyH'));

});

parcelRegister("aYbsr", function(module, exports) {

let $7fc865388b2cddea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7fc865388b2cddea$var$load("bXUvd").then(()=>parcelRequire('e6TPF'));

});

parcelRegister("acx6k", function(module, exports) {

let $76d4b38e8201bd79$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $76d4b38e8201bd79$var$load("26c2h").then(()=>parcelRequire('7piBv'));

});

parcelRegister("iWCTF", function(module, exports) {

let $dcabd0daf6868c6b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dcabd0daf6868c6b$var$load("3lk6X").then(()=>parcelRequire('3yXQ1'));

});

parcelRegister("2tWj9", function(module, exports) {

let $1ceb84f13c590a70$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1ceb84f13c590a70$var$load("huBNP").then(()=>parcelRequire('cmwLF'));

});

parcelRegister("arh0c", function(module, exports) {

let $79999d4c2faee95d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $79999d4c2faee95d$var$load("5tJYH").then(()=>parcelRequire('brRUk'));

});

parcelRegister("fb826", function(module, exports) {

let $b0ce1d3dbf7b805f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b0ce1d3dbf7b805f$var$load("ewhxr").then(()=>parcelRequire('dwyZc'));

});

parcelRegister("iO6my", function(module, exports) {

let $db11d5024549f94a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $db11d5024549f94a$var$load("boWJM").then(()=>parcelRequire('9sIt4'));

});

parcelRegister("cXcSd", function(module, exports) {

let $96e4fb255f7ce319$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $96e4fb255f7ce319$var$load("eNHPW").then(()=>parcelRequire('7UyZr'));

});

parcelRegister("bIQJz", function(module, exports) {

let $888cb5a34d15a279$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $888cb5a34d15a279$var$load("kUBpV").then(()=>parcelRequire('2KPYZ'));

});

parcelRegister("8ILPc", function(module, exports) {

let $659787c6ebdd7679$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $659787c6ebdd7679$var$load("baUsS").then(()=>parcelRequire('9lVxQ'));

});

parcelRegister("hUid6", function(module, exports) {

let $d095cad68f060ea0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d095cad68f060ea0$var$load("d0r9z").then(()=>parcelRequire('1HfnT'));

});

parcelRegister("4ZlVU", function(module, exports) {

let $3a1ddf5858170b02$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3a1ddf5858170b02$var$load("hG1ar").then(()=>parcelRequire('9JBuG'));

});

parcelRegister("ft0CM", function(module, exports) {

let $b42a0c6fad21d679$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b42a0c6fad21d679$var$load("kMyku").then(()=>parcelRequire('aHqTQ'));

});

parcelRegister("4EGFU", function(module, exports) {

let $363c002ee4aa7beb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $363c002ee4aa7beb$var$load("3xL2F").then(()=>parcelRequire('34wuK'));

});

parcelRegister("hJUgO", function(module, exports) {

let $cea249b3255b390d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cea249b3255b390d$var$load("7Ysw6").then(()=>parcelRequire('g36Mb'));

});

parcelRegister("26Y6c", function(module, exports) {

let $189ac2b9db3551f0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $189ac2b9db3551f0$var$load("7sOKp").then(()=>parcelRequire('eODbN'));

});

parcelRegister("k2jJ5", function(module, exports) {

let $e9634bc35b15b21e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e9634bc35b15b21e$var$load("jvUhP").then(()=>parcelRequire('2k3z5'));

});

parcelRegister("8t1lq", function(module, exports) {

let $62a2133071fe9094$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $62a2133071fe9094$var$load("fhT77").then(()=>parcelRequire('lHAGV'));

});

parcelRegister("9uiEL", function(module, exports) {

let $6e85632d71c22264$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6e85632d71c22264$var$load("cpTbC").then(()=>parcelRequire('iPw5B'));

});

parcelRegister("lghtg", function(module, exports) {

let $f7a8a4f4e0eff5ee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f7a8a4f4e0eff5ee$var$load("2iL13").then(()=>parcelRequire('3LgSg'));

});

parcelRegister("3qEIn", function(module, exports) {

let $27f361e80ece6b26$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $27f361e80ece6b26$var$load("9RGBF").then(()=>parcelRequire('bRkOn'));

});

parcelRegister("fbkFk", function(module, exports) {

let $b0d7e9d4cfa90463$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b0d7e9d4cfa90463$var$load("gQYVn").then(()=>parcelRequire('eoGOF'));

});

parcelRegister("lcUNq", function(module, exports) {

let $f706c67fd5e57d65$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f706c67fd5e57d65$var$load("11yNG").then(()=>parcelRequire('jWqmd'));

});

parcelRegister("7isp4", function(module, exports) {

let $55003f27c5d67294$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $55003f27c5d67294$var$load("6IOAT").then(()=>parcelRequire('bzVC8'));

});

parcelRegister("3eS8z", function(module, exports) {
const $355516be41f684c4$export$e98932ab9e22c265 = ({ dependency: dependency, searchSessionId: searchSessionId, reason: reason, source: source, actionSubject: actionSubject })=>{
    return {
        source: source,
        action: 'degradedDependency',
        actionSubject: actionSubject,
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                degradedDependency: dependency,
                reason: reason,
                searchSessionId: searchSessionId
            }
        }
    };
};
const $355516be41f684c4$export$7199f2d13e6ae9f7 = ({ dependency: dependency, searchSessionId: searchSessionId, source: source, actionSubject: actionSubject })=>{
    return {
        source: source,
        action: 'failedDependency',
        actionSubject: actionSubject,
        eventType: 'operational',
        attributes: {
            additionalAttributes: {
                failedDependency: dependency,
                searchSessionId: searchSessionId
            }
        }
    };
};
const $355516be41f684c4$export$786813d6840571a0 = ({ requestName: requestName, searchSessionId: searchSessionId, cacheHit: cacheHit, refreshTriggered: refreshTriggered, source: source, actionSubject: actionSubject })=>{
    return {
        source: source,
        action: 'requestCacheAccess',
        actionSubject: actionSubject,
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                requestName: requestName,
                cacheHit: cacheHit,
                refreshTriggered: refreshTriggered,
                searchSessionId: searchSessionId
            }
        }
    };
};
const $355516be41f684c4$var$baseVitalStatsEvent = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, action: action, moreContext: moreContext })=>{
    return {
        action: action,
        actionSubject: 'ui',
        eventType: 'operational',
        attributes: {
            additionalAttributes: {
                task: task,
                taskId: taskId,
                hostname: typeof window !== 'undefined' ? window.location.hostname : '',
                searchSessionId: searchSessionId,
                ...moreContext
            }
        }
    };
};
const $355516be41f684c4$export$656fa717a09eb821 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $355516be41f684c4$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskStart',
        moreContext: moreContext
    });
};
const $355516be41f684c4$export$3e9761d670712e50 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $355516be41f684c4$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskSuccess',
        moreContext: moreContext
    });
};
const $355516be41f684c4$export$2e311f5a2c70a936 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $355516be41f684c4$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskFail',
        moreContext: moreContext
    });
};
const $355516be41f684c4$export$807d68038784dd59 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $355516be41f684c4$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskAbort',
        moreContext: moreContext
    });
};
module.exports["onDegradedDependency"] = $355516be41f684c4$export$e98932ab9e22c265;
module.exports["onFailedDependency"] = $355516be41f684c4$export$7199f2d13e6ae9f7;
module.exports["onRequestCacheAccess"] = $355516be41f684c4$export$786813d6840571a0;
module.exports["onTaskStart"] = $355516be41f684c4$export$656fa717a09eb821;
module.exports["onTaskSuccess"] = $355516be41f684c4$export$3e9761d670712e50;
module.exports["onTaskFail"] = $355516be41f684c4$export$2e311f5a2c70a936;

});

parcelRegister("92KTD", function(module, exports) {
/**
 * Task name suffixes for vital stats tracking.
 * The full task name is: `${surfacePrefix}/${TASK_SUFFIX}`
 * e.g., 'search-page/first-party-config-ux' or 'quick-find/first-party-config-ux'
 */ const $80e9eb5613483f46$export$5f386c08e1416f1e = {
    FIRST_PARTY_CONFIG_UX: 'first-party-config-ux',
    FIRST_PARTY_CONFIG_NETWORK: 'first-party-config-network',
    THIRD_PARTY_CONFIG_UX: 'third-party-config-ux',
    THIRD_PARTY_CONFIG_NETWORK: 'third-party-config-network',
    COMBINED_CONFIG_UX: 'combined-config-ux',
    COMBINED_CONFIG_NETWORK: 'combined-config-network'
};
module.exports["CONFIG_TASK_SUFFIXES"] = $80e9eb5613483f46$export$5f386c08e1416f1e;

});

parcelRegister("7fkiQ", function(module, exports) {

const $58b4d704abb45fc1$export$577bc64d11eec8be = (surfacePrefix, suffix)=>`${surfacePrefix}/${suffix}`;
module.exports["buildTaskName"] = $58b4d704abb45fc1$export$577bc64d11eec8be;

});

parcelRegister("coUcA", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $004bdc04c72c9ff4$export$b302f369ee895eac = ()=>(0, $iDrrr.fg)('rovo_t26_eu_code_search_m2');
const $004bdc04c72c9ff4$export$7b6d1790fa3f8f2e = ()=>(0, $iDrrr.fg)('rovo_t26_eu_code_search_m2') || (0, $iDrrr.fg)('rovo_t26_eu_code_search');
const $004bdc04c72c9ff4$export$aaeeae77a2d80487 = ()=>!(0, $iDrrr.fg)('rovo_t26_eu_code_search_m2') && !(0, $iDrrr.fg)('rovo_t26_eu_code_search') && (0, $iDrrr.fg)('rovo_github_code_search');
const $004bdc04c72c9ff4$export$ccc71f0dafe0e497 = ()=>(0, $iDrrr.fg)('rovo_t26_eu_code_search_m2') || (0, $iDrrr.fg)('rovo_t26_eu_code_search') || (0, $iDrrr.fg)('rovo_github_code_search');
const $004bdc04c72c9ff4$var$DOCUMENT_TYPE_KEY = 'document';
const $004bdc04c72c9ff4$export$960dc2d6e44432c6 = ({ products: products, selectedTypes: selectedTypes, isAllProductSearch: isAllProductSearch, codeHostProductKeys: codeHostProductKeys, githubProductKeys: githubProductKeys })=>{
    if ((0, $iDrrr.fg)('rovo_t26_eu_code_search_m2') || (0, $iDrrr.fg)('rovo_t26_eu_code_search')) {
        // Permissive `.some`, so the Relay code fragment is never omitted while a filter entry
        // still carries the entity.
        if (products.some((product)=>codeHostProductKeys.includes(product)) && selectedTypes.includes($004bdc04c72c9ff4$var$DOCUMENT_TYPE_KEY)) return 'document';
        // Strict, so mixing a code host with another product does not pull code in.
        if (!isAllProductSearch && selectedTypes.length === 0 && products.length === 1 && codeHostProductKeys.includes(products[0]) && (0, $iDrrr.fg)('rovo_t26_eu_code_search_m2')) return 'all-types';
        return 'none';
    }
    if (products.length === 1 && githubProductKeys.includes(products[0]) && (0, $iDrrr.fg)('rovo_github_code_search')) return 'legacy-github';
    return 'none';
};
module.exports["isCodeSearchEnabled"] = $004bdc04c72c9ff4$export$7b6d1790fa3f8f2e;
module.exports["isLegacyCodeSearchEnabled"] = $004bdc04c72c9ff4$export$aaeeae77a2d80487;
module.exports["isAnyCodeSearchEnabled"] = $004bdc04c72c9ff4$export$ccc71f0dafe0e497;
module.exports["getCodeSearchScope"] = $004bdc04c72c9ff4$export$960dc2d6e44432c6;

});

parcelRegister("5PPrc", function(module, exports) {
const $b36df32f21d2d1ae$export$49f6cbb853d30562 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    Repository: 'repository',
    PullRequest: 'pull-request',
    Branch: 'branch',
    Commit: 'commit',
    DevopsWorkItem: 'devops-work-item',
    WebPage: 'web-page',
    Conversation: 'conversation',
    Message: 'message',
    Video: 'video',
    Design: 'design',
    Page: 'page',
    Blogpost: 'blogpost',
    Attachment: 'attachment',
    Space: 'space',
    Whiteboard: 'whiteboard',
    Slide: 'slide',
    Comment: 'comment',
    Database: 'database',
    Embed: 'embed',
    Folder: 'folder',
    Calendar: 'calendar',
    SpaceCalendar: 'space-calendar',
    Question: 'question',
    Answer: 'answer',
    Issue: 'issue',
    Epic: 'epic',
    Bug: 'bug',
    Story: 'story',
    Task: 'task',
    Subtask: 'subtask',
    Project: 'project',
    Incident: 'incident',
    Filter: 'filter',
    Plan: 'plan',
    Board: 'board',
    Component: 'component',
    Card: 'card',
    Goal: 'goal',
    Tag: 'tag',
    WorkItem: 'work-item',
    FocusArea: 'focus-area',
    Organization: 'organization',
    Ask: 'ask',
    Risk: 'risk',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Deal: 'deal',
    Gliffy: 'gliffy',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Type: 'type',
    Schema: 'schema',
    Position: 'position',
    Image: 'image',
    Audio: 'audio',
    Pdf: 'pdf',
    Shortcut: 'shortcut',
    Code: 'code',
    Archive: 'archive',
    Other: 'other',
    Notebook: 'notebook',
    Form: 'form',
    Article: 'article',
    Post: 'post',
    Ticket: 'ticket',
    Campaign: 'campaign',
    Case: 'case',
    CatalogItem: 'catalog-item',
    RequestedItem: 'requested-item',
    Demand: 'demand',
    KnowledgeArticle: 'knowledge-article',
    NewsArticle: 'news-article',
    Lead: 'lead'
};
const $b36df32f21d2d1ae$export$e01073b80ff953d5 = Object.values($b36df32f21d2d1ae$export$49f6cbb853d30562);
const $b36df32f21d2d1ae$export$1f2db89e0caa00c9 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    File: 'file',
    Database: 'database',
    WebPage: 'web-page',
    Page: 'page',
    Blogpost: 'blogpost',
    Article: 'article',
    Post: 'post',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Design: 'design',
    Deal: 'deal',
    Video: 'video',
    Task: 'task',
    Issue: 'issue',
    Space: 'space',
    Project: 'project',
    Repository: 'repository',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    Image: 'image',
    Archive: 'archive',
    Audio: 'audio',
    Code: 'code',
    Pdf: 'pdf',
    Other: 'other',
    Software: 'software',
    ServiceDesk: 'service_desk',
    Business: 'business',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Schema: 'schema',
    Type: 'type',
    Folder: 'folder',
    Notebook: 'notebook',
    Form: 'form',
    Shortcut: 'shortcut',
    Site: 'site',
    Subsite: 'subsite',
    Drive: 'drive',
    Comment: 'comment',
    Incident: 'incident',
    CatalogItem: 'catalog_item',
    RequestedItem: 'requested_item',
    KnowledgeArticle: 'knowledge_article',
    Demand: 'demand',
    NewsArticle: 'news_article',
    Epic: 'epic'
};
/**
 * Maps CloudGraph ATI to TypeFilterValueKey
 */ const $b36df32f21d2d1ae$var$ATI_TO_TYPE_FILTER_KEY_MAP = {
    'ati:cloud:graph:document': $b36df32f21d2d1ae$export$49f6cbb853d30562.Document,
    'ati:cloud:graph:message': $b36df32f21d2d1ae$export$49f6cbb853d30562.Message,
    'ati:cloud:graph:conversation': $b36df32f21d2d1ae$export$49f6cbb853d30562.Conversation,
    'ati:cloud:graph:design': $b36df32f21d2d1ae$export$49f6cbb853d30562.Design,
    'ati:cloud:graph:video': $b36df32f21d2d1ae$export$49f6cbb853d30562.Video,
    'ati:cloud:graph:space': $b36df32f21d2d1ae$export$49f6cbb853d30562.Space,
    'ati:cloud:graph:comment': $b36df32f21d2d1ae$export$49f6cbb853d30562.Comment,
    'ati:cloud:graph:repository': $b36df32f21d2d1ae$export$49f6cbb853d30562.Repository,
    'ati:cloud:graph:pull-request': $b36df32f21d2d1ae$export$49f6cbb853d30562.PullRequest,
    'ati:cloud:graph:commit': $b36df32f21d2d1ae$export$49f6cbb853d30562.Commit,
    'ati:cloud:graph:branch': $b36df32f21d2d1ae$export$49f6cbb853d30562.Branch,
    'ati:cloud:graph:calendar-event': $b36df32f21d2d1ae$export$49f6cbb853d30562.Calendar,
    'ati:cloud:graph:work-item': $b36df32f21d2d1ae$export$49f6cbb853d30562.WorkItem,
    'ati:cloud:graph:project': $b36df32f21d2d1ae$export$49f6cbb853d30562.Project,
    'ati:cloud:graph:deal': $b36df32f21d2d1ae$export$49f6cbb853d30562.Deal,
    'ati:cloud:graph:customer-org': $b36df32f21d2d1ae$export$49f6cbb853d30562.CustomerOrg,
    'ati:cloud:graph:customer-contact': $b36df32f21d2d1ae$export$49f6cbb853d30562.CustomerContact,
    'ati:cloud:graph:dashboard': $b36df32f21d2d1ae$export$49f6cbb853d30562.Dashboard,
    'ati:cloud:graph:data-table': $b36df32f21d2d1ae$export$49f6cbb853d30562.DataTable,
    'ati:cloud:graph:campaign': $b36df32f21d2d1ae$export$49f6cbb853d30562.Campaign,
    'ati:cloud:graph:case': $b36df32f21d2d1ae$export$49f6cbb853d30562.Case,
    'ati:cloud:graph:lead': $b36df32f21d2d1ae$export$49f6cbb853d30562.Lead
};
/**
 * Checks if an ATI string is a CloudGraph ATI
 */ const $b36df32f21d2d1ae$var$isCloudGraphAti = (ati)=>{
    return ati.startsWith('ati:cloud:graph:');
};
function $b36df32f21d2d1ae$export$770175465f396551(atis) {
    const typeFilterConfig = new Map();
    // Group ATIs by their corresponding TypeFilterValueKey
    const atisByTypeKey = new Map();
    for (const ati of atis)if ($b36df32f21d2d1ae$var$isCloudGraphAti(ati)) {
        const typeKey = $b36df32f21d2d1ae$var$ATI_TO_TYPE_FILTER_KEY_MAP[ati];
        if (typeKey) {
            if (!atisByTypeKey.has(typeKey)) atisByTypeKey.set(typeKey, []);
            atisByTypeKey.get(typeKey).push(ati);
        }
    }
    // Convert to TypeFilterConfig3P format
    for (const [typeKey, entityAtis] of atisByTypeKey)typeFilterConfig.set(typeKey, {
        entities3P: entityAtis,
        subTypes3P: [] // Most configs use empty subTypes3P, can be extended if needed
    });
    return typeFilterConfig;
}
module.exports["TypeFilterValueKey"] = $b36df32f21d2d1ae$export$49f6cbb853d30562;
module.exports["NounSubtypeKey"] = $b36df32f21d2d1ae$export$1f2db89e0caa00c9;
module.exports["mapAtisToTypeFilterConfig"] = $b36df32f21d2d1ae$export$770175465f396551;

});

parcelRegister("i52Hf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");




var $6suVE = parcelRequire("6suVE");


var $ehKBQ = parcelRequire("ehKBQ");


var $iS3Tu = parcelRequire("iS3Tu");


var $dULnI = parcelRequire("dULnI");


var $2sFbd = parcelRequire("2sFbd");



var $9Jc29 = parcelRequire("9Jc29");





var $Douji = parcelRequire("Douji");


var $iPmoS = parcelRequire("iPmoS");

const $8a7a1ec4b7d3b7f4$var$svgIconContainerStyles = {
    small: "_39xV02ey7F _0jFU0Vey7F _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    medium: "_39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    large: "_39xV02Uofl _0jFU0VUofl _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    xlarge: "_39xV02Uofl _0jFU0VUofl _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
};
const $8a7a1ec4b7d3b7f4$var$SVGIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { glyph: SVG, label: label, size: size } = t0;
    const t1 = $8a7a1ec4b7d3b7f4$var$svgIconContainerStyles[size];
    const t2 = label || undefined;
    const t3 = label ? "img" : "presentation";
    let t4;
    if ($[0] !== SVG || $[1] !== size) {
        t4 = (0, $iDrrr.fg)("rovo-search-team-eu-26-brand-icon-library") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, {
            size: size === "small" ? "xxsmall" : size === "medium" ? "small" : "medium"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, null);
        $[0] = SVG;
        $[1] = size;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== t1 || $[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t1,
            "aria-label": t2,
            role: t3
        }, t4);
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ glyph: SVG, label: label, size: size })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $8a7a1ec4b7d3b7f4$var$svgIconContainerStyles[size],
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation'
    }, (0, $iDrrr.fg)('rovo-search-team-eu-26-brand-icon-library') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, {
        size: size === 'small' ? 'xxsmall' : size === 'medium' ? 'small' : 'medium'
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, null));
};
const $8a7a1ec4b7d3b7f4$var$isCorrectableRovoSize = (size)=>{
    return [
        'xxsmall',
        'xsmall',
        'small',
        'medium',
        'large'
    ].includes(size);
};
const $8a7a1ec4b7d3b7f4$var$correctedSize = {
    xxsmall: 'small',
    xsmall: 'small',
    small: 'medium',
    medium: 'large',
    large: 'xlarge'
};
const $8a7a1ec4b7d3b7f4$var$sizeStyles = {
    small: "_39xV02ey7F _0jFU0Vey7F",
    medium: "_39xV02oWWg _0jFU0VoWWg",
    large: "_39xV02Uofl _0jFU0VUofl",
    xlarge: "_39xV02pJKa _0jFU0VpJKa"
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with custom Rovo Icons
    *
    * Internally uses <Icon glyph={glyph} ... />
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $8a7a1ec4b7d3b7f4$export$7b66a86355afbb91 = (Glyph, defaultLabel = '', defaultSize = 'medium')=>{
    return ({ size: size = defaultSize, label: label = defaultLabel, testId: testId })=>{
        const mappedSize = size && $8a7a1ec4b7d3b7f4$var$isCorrectableRovoSize(size) ? $8a7a1ec4b7d3b7f4$var$correctedSize[size] : defaultSize;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-label": label || undefined,
            "data-testid": testId,
            role: label ? 'img' : 'presentation',
            className: (0, $hekY6.default)([
                $8a7a1ec4b7d3b7f4$var$sizeStyles[mappedSize]
            ])
        }, (0, $iDrrr.fg)('rovo-search-team-eu-26-brand-icon-library') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Glyph, {
            size: mappedSize === 'small' ? 'xxsmall' : mappedSize === 'medium' ? 'small' : mappedSize === 'large' ? 'medium' : 'xlarge'
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Glyph, null));
    };
}; /**
    * A wrapper for rendering 3P svg illustrations in a similar way for atlaskit icon components
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d = (glyph, defaultLabel = '', defaultSize)=>{
    return ({ label: label = defaultLabel, size: size = defaultSize })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8a7a1ec4b7d3b7f4$var$SVGIcon, {
            label: label,
            glyph: glyph,
            size: size && $8a7a1ec4b7d3b7f4$var$isCorrectableRovoSize(size) ? $8a7a1ec4b7d3b7f4$var$correctedSize[size] : 'medium'
        });
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with \@atlaskit/logo
    *
    * Internally uses <LogoComponent ... />
    *
    * @param {} LogoComponent an import from \@atlaskit/logo
    * @param defaultLabel an accessible label for the logo
    */ 
const $8a7a1ec4b7d3b7f4$export$32db889b380fa03c = (LogoComponent, defaultLabel = '')=>{
    return ({ size: size, label: label, testId: testId })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LogoComponent, {
            label: label || defaultLabel,
            testId: testId,
            size: size || 'medium',
            appearance: "brand"
        });
    };
}; /**
    * Takes a logo component and returns a new logo component that uses the new logo design.
    */ 
function $8a7a1ec4b7d3b7f4$export$a34cd1871c6541c9(Icon) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, props);
}
function $8a7a1ec4b7d3b7f4$export$fab9faef3411dc6c(iconGlyph, iconLabel, size) {
    return $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d(iconGlyph, iconLabel, size);
}
const $8a7a1ec4b7d3b7f4$var$imageStyles = null; /**
                           * Helper function to convert an image URL into a glyph function
                           *
                           * @param imageUrl URL string pointing to the image
                           * @returns A glyph function that returns an img element
                           */ 
const $8a7a1ec4b7d3b7f4$export$f9f7178f66750cba = (imageUrl)=>{
    return ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: imageUrl,
            alt: "",
            className: (0, $hekY6.default)([
                "_39xV02N91d _0jFU0VN91d _00EA0egIor"
            ])
        });
    };
}; /**
    * Creates a RovoLogo from a URL. Useful for Forge connectors that provide icon URLs.
    * Uses the existing RovoLogoFromSVG infrastructure for consistent handling.
    */ 
function $8a7a1ec4b7d3b7f4$export$97ac28be52c9e29f(iconUrl, iconLabel, size) {
    return $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d($8a7a1ec4b7d3b7f4$export$f9f7178f66750cba(iconUrl), iconLabel, size);
} // Jira-specific icons
module.exports["RovoLogoFromGlyph"] = $8a7a1ec4b7d3b7f4$export$7b66a86355afbb91;
module.exports["RovoLogoFromSVG"] = $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d;
module.exports["RovoLogoFromLogo"] = $8a7a1ec4b7d3b7f4$export$32db889b380fa03c;
module.exports["get3PLogo"] = $8a7a1ec4b7d3b7f4$export$fab9faef3411dc6c;
module.exports["get3PLogoFromURL"] = $8a7a1ec4b7d3b7f4$export$97ac28be52c9e29f;

});

parcelRegister("6suVE", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $db93e344a28daeff$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4hzFj")).then((m)=>m.GitHubIcon), {
    moduleId: '@atlassian/logo-third-party/github'
});

const $db93e344a28daeff$var$LazyGithubIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("3w7xz")).then((m)=>m.GithubIcon), {
    moduleId: '@atlassian/rovo-connectors-config/github/icon'
});

const $db93e344a28daeff$var$LazyGithubSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("3w7xz")).then((m)=>m.GithubSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/github/search-result-icon'
});
const $db93e344a28daeff$export$e8e65f186ccd8749 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db93e344a28daeff$var$LazyGithubIconComponent, null)), $db93e344a28daeff$var$OfficialIcon, 'small');
const $db93e344a28daeff$export$fa0f141eb732d2d7 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db93e344a28daeff$var$LazyGithubSearchResultIconComponent, null)), $db93e344a28daeff$var$OfficialIcon, 'medium');
module.exports["GithubIcon"] = $db93e344a28daeff$export$e8e65f186ccd8749;
module.exports["GithubSearchResultIcon"] = $db93e344a28daeff$export$fa0f141eb732d2d7;

});

parcelRegister("4hzFj", function(module, exports) {

let $31e46a58d87c0f49$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $31e46a58d87c0f49$var$load("jxGqt").then(()=>parcelRequire('fyTd1'));

});

parcelRegister("3w7xz", function(module, exports) {

let $28fa35a07f4c32d8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $28fa35a07f4c32d8$var$load("ECQ6q").then(()=>parcelRequire('kGNh6'));

});

parcelRegister("ehKBQ", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $6ce68911b0df4e15$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9dtYX")).then((m)=>m.GitlabIcon), {
    moduleId: '@atlassian/logo-third-party/gitlab'
});

const $6ce68911b0df4e15$var$LazyGitlabIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ilgI1")).then((m)=>m.GitlabIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/icon'
});

const $6ce68911b0df4e15$var$LazyGitlabSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ilgI1")).then((m)=>m.GitlabSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/search-result-icon'
});

const $6ce68911b0df4e15$var$LazyGitlabIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ilgI1")).then((m)=>m.GitlabIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/icon-borderless'
});
const $6ce68911b0df4e15$export$8b4e5326778cce0f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabIconComponent, null)), $6ce68911b0df4e15$var$OfficialIcon, 'small');
const $6ce68911b0df4e15$export$b828123bc19648f9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabSearchResultIconComponent, null)), $6ce68911b0df4e15$var$OfficialIcon, 'medium');
const $6ce68911b0df4e15$export$7e0d364467f49036 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabIconBorderlessComponent, null)), $6ce68911b0df4e15$var$OfficialIcon, 'xxsmall');
module.exports["GitlabIcon"] = $6ce68911b0df4e15$export$8b4e5326778cce0f;
module.exports["GitlabSearchResultIcon"] = $6ce68911b0df4e15$export$b828123bc19648f9;
module.exports["GitlabIconBorderless"] = $6ce68911b0df4e15$export$7e0d364467f49036;

});

parcelRegister("9dtYX", function(module, exports) {

let $6b5c95c494a16587$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b5c95c494a16587$var$load("4LY4N").then(()=>parcelRequire('kmcLM'));

});

parcelRegister("ilgI1", function(module, exports) {

let $d5a726386ad88d53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d5a726386ad88d53$var$load("1p9Ip").then(()=>parcelRequire('hYL6T'));

});

parcelRegister("iS3Tu", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $83bbbb3fda08bb6a$var$LazyGitbookIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lbDA4")).then((m)=>m.GitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitbook/icon'
});

const $83bbbb3fda08bb6a$var$LazyGitbookSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lbDA4")).then((m)=>m.GitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitbook/search-result-icon'
});
const $83bbbb3fda08bb6a$export$6da1c7984975c183 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookIconComponent, null));
const $83bbbb3fda08bb6a$export$65b356f251826206 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookSearchResultIconComponent, null));
module.exports["GitbookIcon"] = $83bbbb3fda08bb6a$export$6da1c7984975c183;
module.exports["GitbookSearchResultIcon"] = $83bbbb3fda08bb6a$export$65b356f251826206;

});

parcelRegister("lbDA4", function(module, exports) {

let $f6c953f826ed6884$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f6c953f826ed6884$var$load("k1ije").then(()=>parcelRequire('lG6hv'));

});

parcelRegister("dULnI", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $2cad9d35507cac43$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("enDSk")).then((m)=>m.MicrosoftAzureDevOpsIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-azure-devops'
});

const $2cad9d35507cac43$var$LazyAzureDevopsIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8WMbv")).then((m)=>m.AzureDevopsIcon), {
    moduleId: '@atlassian/rovo-connectors-config/azure-devops/icon'
});

const $2cad9d35507cac43$var$LazyAzureDevopsSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8WMbv")).then((m)=>m.AzureDevopsSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/azure-devops/search-result-icon'
});
const $2cad9d35507cac43$export$2dcf704e717ca168 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2cad9d35507cac43$var$LazyAzureDevopsIconComponent, null)), $2cad9d35507cac43$var$OfficialIcon, 'small');
const $2cad9d35507cac43$export$a64bb17da4dc2efb = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2cad9d35507cac43$var$LazyAzureDevopsSearchResultIconComponent, null)), $2cad9d35507cac43$var$OfficialIcon, 'medium');
module.exports["AzureDevopsIcon"] = $2cad9d35507cac43$export$2dcf704e717ca168;
module.exports["AzureDevopsSearchResultIcon"] = $2cad9d35507cac43$export$a64bb17da4dc2efb;

});

parcelRegister("enDSk", function(module, exports) {

let $a782250e15e8574e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a782250e15e8574e$var$load("jLsGY").then(()=>parcelRequire('b9s7D'));

});

parcelRegister("8WMbv", function(module, exports) {

let $68391df23b860e75$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $68391df23b860e75$var$load("axvMK").then(()=>parcelRequire('fTk3N'));

});

parcelRegister("2sFbd", function(module, exports) {
/**
 * Lazy-loaded Slack icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $809b94d6e1c8821b$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ln0Jc")).then((m)=>m.SlackIcon), {
    moduleId: '@atlassian/logo-third-party/slack'
});

// Lazy load the actual icon components from utils
const $809b94d6e1c8821b$var$LazySlackIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackIcon), {
    moduleId: '@atlassian/rovo-connectors-config/slack/icon'
});

const $809b94d6e1c8821b$var$LazySlackIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/slack/icon-borderless'
});

const $809b94d6e1c8821b$var$LazySlackSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/slack/search-result-icon'
});

const $809b94d6e1c8821b$var$LazySlackAppSelectorIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackAppSelectorIcon), {
    moduleId: '@atlassian/rovo-connectors-config/slack/app-selector-icon'
});
const $809b94d6e1c8821b$export$b33fb54b08bb6422 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackIconComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'small');
const $809b94d6e1c8821b$export$359ca796b415372 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackIconBorderlessComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'xxsmall');
const $809b94d6e1c8821b$export$9e3ecebaf98513b9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackSearchResultIconComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'medium');
const $809b94d6e1c8821b$export$f11b42d1aefdd173 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackAppSelectorIconComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'xxsmall');
module.exports["SlackIcon"] = $809b94d6e1c8821b$export$b33fb54b08bb6422;
module.exports["SlackIconBorderless"] = $809b94d6e1c8821b$export$359ca796b415372;
module.exports["SlackSearchResultIcon"] = $809b94d6e1c8821b$export$9e3ecebaf98513b9;

});

parcelRegister("ln0Jc", function(module, exports) {

let $f8ec4f8a6e6abecf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f8ec4f8a6e6abecf$var$load("7S2Sh").then(()=>parcelRequire('eaD9b'));

});

parcelRegister("iCjpP", function(module, exports) {

let $d8dad6234f740135$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d8dad6234f740135$var$load("hUTu6").then(()=>parcelRequire('gaQ0m'));

});

parcelRegister("Douji", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $216cd14c42636556$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("60nw9")).then((m)=>m.MicrosoftSharePointIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-sharepoint'
});

const $216cd14c42636556$var$LazySharePointIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kabYe")).then((m)=>m.SharePointIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sharepoint/icon'
});

const $216cd14c42636556$var$LazySharePointSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kabYe")).then((m)=>m.SharePointSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sharepoint/search-result-icon'
});

const $216cd14c42636556$var$LazySharepointIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kabYe")).then((m)=>m.SharepointIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/sharepoint/icon-borderless'
});
const $216cd14c42636556$export$53d8bcde0f28cd56 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharePointIconComponent, null)), $216cd14c42636556$var$OfficialIcon, 'small');
const $216cd14c42636556$export$65b9e0ddb04a51a1 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharePointSearchResultIconComponent, null)), $216cd14c42636556$var$OfficialIcon, 'medium');
const $216cd14c42636556$export$a0d18fc9cea4f40e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharepointIconBorderlessComponent, null)), $216cd14c42636556$var$OfficialIcon, 'xxsmall');
module.exports["SharePointIcon"] = $216cd14c42636556$export$53d8bcde0f28cd56;
module.exports["SharePointSearchResultIcon"] = $216cd14c42636556$export$65b9e0ddb04a51a1;
module.exports["SharepointIconBorderless"] = $216cd14c42636556$export$a0d18fc9cea4f40e;

});

parcelRegister("60nw9", function(module, exports) {

let $45f4fc3fccb59bad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $45f4fc3fccb59bad$var$load("i8lZ0").then(()=>parcelRequire('8RTwe'));

});

parcelRegister("kabYe", function(module, exports) {

let $eade06eb3e209cb5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eade06eb3e209cb5$var$load("c2llp").then(()=>parcelRequire('58jvK'));

});

parcelRegister("iPmoS", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $b77f1e6828d0ac82$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4hzFj")).then((m)=>m.GitHubIcon), {
    moduleId: '@atlassian/logo-third-party/github'
});

const $b77f1e6828d0ac82$var$LazyForgePioGithubIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9RFVr")).then((m)=>m.ForgePioGithubIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-github-prod/icon'
});

const $b77f1e6828d0ac82$var$LazyForgePioGithubSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9RFVr")).then((m)=>m.ForgePioGithubSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-github-prod/search-result-icon'
});
const $b77f1e6828d0ac82$export$f1d7e8d930f0538e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b77f1e6828d0ac82$var$LazyForgePioGithubIconComponent, null)), $b77f1e6828d0ac82$var$OfficialIcon, 'small');
const $b77f1e6828d0ac82$export$f318f463f9328f3f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b77f1e6828d0ac82$var$LazyForgePioGithubSearchResultIconComponent, null)), $b77f1e6828d0ac82$var$OfficialIcon, 'medium');
module.exports["ForgePioGithubIcon"] = $b77f1e6828d0ac82$export$f1d7e8d930f0538e;
module.exports["ForgePioGithubSearchResultIcon"] = $b77f1e6828d0ac82$export$f318f463f9328f3f;

});

parcelRegister("9RFVr", function(module, exports) {

let $72e995d3df53c84c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $72e995d3df53c84c$var$load("cNleL").then(()=>parcelRequire('gcarM'));

});


//# sourceMappingURL=hooks.94a7ae0f.js.map
